/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export interface BooleanFilter {
  value: boolean;
  count: number;
  price: number;
  label: string;
}

export interface StringFilter {
  count: number;
  price: number;
  value: string;
  label: string;
}

export interface AirportFilter {
  count: number;
  price: number;
  distance: number;
  value: string;
  label: string;
}

export interface FloatFilter {
  count: number;
  price: number;
  value: number;
  label: string;
}

export interface IntFilter {
  value: number;
  count: number;
  price: number;
  label: string;
}

export interface UintFilter {
  value: number;
  count: number;
  price: number;
  label: string;
}

export interface FilterItems {
  actionAndFun?: BooleanFilter;
  adultsOnly?: BooleanFilter;
  ayurveda?: BooleanFilter;
  babyCot?: BooleanFilter;
  babyEquipment?: BooleanFilter;
  babySitting?: BooleanFilter;
  beautyFarm?: BooleanFilter;
  buggyRent?: BooleanFilter;
  cancellationOption?: BooleanFilter;
  cancellationCost?: BooleanFilter;
  cancellationShortlyBefore?: BooleanFilter;
  centralLocation?: BooleanFilter;
  charmFlair?: BooleanFilter;
  childFriendly?: BooleanFilter;
  childrenBuffet?: BooleanFilter;
  childrenPlayground?: BooleanFilter;
  childrenPlayroom?: BooleanFilter;
  childrenPool?: BooleanFilter;
  cityBreaks?: BooleanFilter;
  club?: BooleanFilter;
  cosmetic?: BooleanFilter;
  culinaryDelights?: BooleanFilter;
  cycling?: BooleanFilter;
  deluxe?: BooleanFilter;
  directBeachAccess?: BooleanFilter;
  directFlight?: BooleanFilter;
  diving?: BooleanFilter;
  familyHoliday?: BooleanFilter;
  fitness?: BooleanFilter;
  flexBooking?: BooleanFilter;
  freeParking?: BooleanFilter;
  freeWlan?: BooleanFilter;
  gentlySlopingSandyBeach?: BooleanFilter;
  germanSpeakingEntertainmentForKids?: BooleanFilter;
  golf?: BooleanFilter;
  greatSportsOffer?: BooleanFilter;
  handicappedAccessible?: BooleanFilter;
  heatedPool?: BooleanFilter;
  hiking?: BooleanFilter;
  holidayForTwo?: BooleanFilter;
  horseRiding?: BooleanFilter;
  hotelNearTheBeach?: BooleanFilter;
  indoorPool?: BooleanFilter;
  internet?: BooleanFilter;
  kidsDisco?: BooleanFilter;
  kiteSurfing?: BooleanFilter;
  laundryService?: BooleanFilter;
  longhaultJourney?: BooleanFilter;
  lowDeposit?: BooleanFilter;
  luggageIncluded?: BooleanFilter;
  massages?: BooleanFilter;
  matchOnlyCheckedAirlines?: BooleanFilter;
  maxiClub?: BooleanFilter;
  medicalService?: BooleanFilter;
  miniClub?: BooleanFilter;
  niceSmallFamilyRun?: BooleanFilter;
  nonSmokingHotel?: BooleanFilter;
  nonSmokingRooms?: BooleanFilter;
  oceanView?: BooleanFilter;
  parkingSpacesAvailable?: BooleanFilter;
  partialOceanView?: BooleanFilter;
  petsAllowed?: BooleanFilter;
  pettingZoo?: BooleanFilter;
  pool?: BooleanFilter;
  promoDiscount?: BooleanFilter;
  railAndFly?: BooleanFilter;
  relaxationOffersForBodyAndSoul?: BooleanFilter;
  restaurant?: BooleanFilter;
  sailing?: BooleanFilter;
  sandyBeach?: BooleanFilter;
  sauna?: BooleanFilter;
  singleWithChild?: BooleanFilter;
  singles?: BooleanFilter;
  soccerSchool?: BooleanFilter;
  specialCommission?: BooleanFilter;
  sportOffersForChildren?: BooleanFilter;
  squash?: BooleanFilter;
  surfing?: BooleanFilter;
  swimSchool?: BooleanFilter;
  tennis?: BooleanFilter;
  thalasso?: BooleanFilter;
  transfer?: BooleanFilter;
  privateTransfer?: BooleanFilter;
  vacationAtMediterraneanSea?: BooleanFilter;
  vacationAtNorthOrBalticSea?: BooleanFilter;
  vacationInAustria?: BooleanFilter;
  vacationInGermany?: BooleanFilter;
  vacationInTheMountains?: BooleanFilter;
  waterSlide?: BooleanFilter;
  waterSports?: BooleanFilter;
  wellness?: BooleanFilter;
  windSurfing?: BooleanFilter;
  wingFoiling?: BooleanFilter;
  winterSports?: BooleanFilter;
  areaId: UintFilter[];
  cityId: UintFilter[];
  hotelCategoryList: UintFilter[];
  unitIds: UintFilter[];
  cancellationDaysBeforeTravelStart: UintFilter[];
  rating: FloatFilter[];
  accommodationType: StringFilter[];
  accommodationCategoryGroup: StringFilter[];
  airlineList: StringFilter[];
  cateringList: StringFilter[];
  offerPaymentTypeList: StringFilter[];
  roomType: StringFilter[];
  touroperator: StringFilter[];
  destinationAirportList: AirportFilter[];
}

/**
 * Deprecated: legacy data structure for desktop search form, will be removed if search form is reimplemented in react
 *
 * @deprecated
 */
export interface FavouriteFilters {
  filterOptionsDisplayMode: string;
  filterOptionsRenderMode: string;
  filterOptionsList: FavouriteFilters_FilterOption[];
  customerFilters: FavouriteFilters_FilterOption[];
}

/** @deprecated */
export interface FavouriteFilters_FilterOption {
  count: number;
  source: string;
  originalValue: string;
  filterKey: string;
  input?: FavouriteFilters_FilterOption_Input;
  label?: FavouriteFilters_FilterOption_Label;
  potential?: FavouriteFilters_FilterOption_Potential;
}

/** @deprecated */
export interface FavouriteFilters_FilterOption_Input {
  isChecked: boolean;
  id: string;
  name: string;
  value: string;
  paramMapKey: string;
  class: string;
}

/** @deprecated */
export interface FavouriteFilters_FilterOption_Label {
  text: string;
  title: string;
  class: string;
  spanClass: string;
}

/** @deprecated */
export interface FavouriteFilters_FilterOption_Potential {
  show: boolean;
  showFilterCount: boolean;
  id: string;
}

function createBaseBooleanFilter(): BooleanFilter {
  return { value: false, count: 0, price: 0, label: "" };
}

export const BooleanFilter = {
  encode(
    message: BooleanFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.value === true) {
      writer.uint32(8).bool(message.value);
    }
    if (message.count !== 0) {
      writer.uint32(16).int32(message.count);
    }
    if (message.price !== 0) {
      writer.uint32(29).float(message.price);
    }
    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BooleanFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBooleanFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.value = reader.bool();
          break;
        case 2:
          message.count = reader.int32();
          break;
        case 3:
          message.price = reader.float();
          break;
        case 4:
          message.label = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): BooleanFilter {
    return {
      value: isSet(object.value) ? Boolean(object.value) : false,
      count: isSet(object.count) ? Number(object.count) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      label: isSet(object.label) ? String(object.label) : "",
    };
  },

  toJSON(message: BooleanFilter): unknown {
    const obj: any = {};
    message.value !== undefined && (obj.value = message.value);
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.price !== undefined && (obj.price = message.price);
    message.label !== undefined && (obj.label = message.label);
    return obj;
  },

  fromPartial(object: DeepPartial<BooleanFilter>): BooleanFilter {
    const message = createBaseBooleanFilter();
    message.value = object.value ?? false;
    message.count = object.count ?? 0;
    message.price = object.price ?? 0;
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseStringFilter(): StringFilter {
  return { count: 0, price: 0, value: "", label: "" };
}

export const StringFilter = {
  encode(
    message: StringFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(8).int32(message.count);
    }
    if (message.price !== 0) {
      writer.uint32(21).float(message.price);
    }
    if (message.value !== "") {
      writer.uint32(26).string(message.value);
    }
    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StringFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStringFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.count = reader.int32();
          break;
        case 2:
          message.price = reader.float();
          break;
        case 3:
          message.value = reader.string();
          break;
        case 4:
          message.label = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): StringFilter {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      value: isSet(object.value) ? String(object.value) : "",
      label: isSet(object.label) ? String(object.label) : "",
    };
  },

  toJSON(message: StringFilter): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.price !== undefined && (obj.price = message.price);
    message.value !== undefined && (obj.value = message.value);
    message.label !== undefined && (obj.label = message.label);
    return obj;
  },

  fromPartial(object: DeepPartial<StringFilter>): StringFilter {
    const message = createBaseStringFilter();
    message.count = object.count ?? 0;
    message.price = object.price ?? 0;
    message.value = object.value ?? "";
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseAirportFilter(): AirportFilter {
  return { count: 0, price: 0, distance: 0, value: "", label: "" };
}

export const AirportFilter = {
  encode(
    message: AirportFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(8).int32(message.count);
    }
    if (message.price !== 0) {
      writer.uint32(21).float(message.price);
    }
    if (message.distance !== 0) {
      writer.uint32(29).float(message.distance);
    }
    if (message.value !== "") {
      writer.uint32(34).string(message.value);
    }
    if (message.label !== "") {
      writer.uint32(42).string(message.label);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AirportFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirportFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.count = reader.int32();
          break;
        case 2:
          message.price = reader.float();
          break;
        case 3:
          message.distance = reader.float();
          break;
        case 4:
          message.value = reader.string();
          break;
        case 5:
          message.label = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AirportFilter {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      distance: isSet(object.distance) ? Number(object.distance) : 0,
      value: isSet(object.value) ? String(object.value) : "",
      label: isSet(object.label) ? String(object.label) : "",
    };
  },

  toJSON(message: AirportFilter): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.price !== undefined && (obj.price = message.price);
    message.distance !== undefined && (obj.distance = message.distance);
    message.value !== undefined && (obj.value = message.value);
    message.label !== undefined && (obj.label = message.label);
    return obj;
  },

  fromPartial(object: DeepPartial<AirportFilter>): AirportFilter {
    const message = createBaseAirportFilter();
    message.count = object.count ?? 0;
    message.price = object.price ?? 0;
    message.distance = object.distance ?? 0;
    message.value = object.value ?? "";
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseFloatFilter(): FloatFilter {
  return { count: 0, price: 0, value: 0, label: "" };
}

export const FloatFilter = {
  encode(
    message: FloatFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(8).int32(message.count);
    }
    if (message.price !== 0) {
      writer.uint32(21).float(message.price);
    }
    if (message.value !== 0) {
      writer.uint32(29).float(message.value);
    }
    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FloatFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFloatFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.count = reader.int32();
          break;
        case 2:
          message.price = reader.float();
          break;
        case 3:
          message.value = reader.float();
          break;
        case 4:
          message.label = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FloatFilter {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      value: isSet(object.value) ? Number(object.value) : 0,
      label: isSet(object.label) ? String(object.label) : "",
    };
  },

  toJSON(message: FloatFilter): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.price !== undefined && (obj.price = message.price);
    message.value !== undefined && (obj.value = message.value);
    message.label !== undefined && (obj.label = message.label);
    return obj;
  },

  fromPartial(object: DeepPartial<FloatFilter>): FloatFilter {
    const message = createBaseFloatFilter();
    message.count = object.count ?? 0;
    message.price = object.price ?? 0;
    message.value = object.value ?? 0;
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseIntFilter(): IntFilter {
  return { value: 0, count: 0, price: 0, label: "" };
}

export const IntFilter = {
  encode(
    message: IntFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.value !== 0) {
      writer.uint32(8).int32(message.value);
    }
    if (message.count !== 0) {
      writer.uint32(16).int32(message.count);
    }
    if (message.price !== 0) {
      writer.uint32(29).float(message.price);
    }
    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IntFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.value = reader.int32();
          break;
        case 2:
          message.count = reader.int32();
          break;
        case 3:
          message.price = reader.float();
          break;
        case 4:
          message.label = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): IntFilter {
    return {
      value: isSet(object.value) ? Number(object.value) : 0,
      count: isSet(object.count) ? Number(object.count) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      label: isSet(object.label) ? String(object.label) : "",
    };
  },

  toJSON(message: IntFilter): unknown {
    const obj: any = {};
    message.value !== undefined && (obj.value = Math.round(message.value));
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.price !== undefined && (obj.price = message.price);
    message.label !== undefined && (obj.label = message.label);
    return obj;
  },

  fromPartial(object: DeepPartial<IntFilter>): IntFilter {
    const message = createBaseIntFilter();
    message.value = object.value ?? 0;
    message.count = object.count ?? 0;
    message.price = object.price ?? 0;
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseUintFilter(): UintFilter {
  return { value: 0, count: 0, price: 0, label: "" };
}

export const UintFilter = {
  encode(
    message: UintFilter,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.value !== 0) {
      writer.uint32(8).uint32(message.value);
    }
    if (message.count !== 0) {
      writer.uint32(16).int32(message.count);
    }
    if (message.price !== 0) {
      writer.uint32(29).float(message.price);
    }
    if (message.label !== "") {
      writer.uint32(34).string(message.label);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UintFilter {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUintFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.value = reader.uint32();
          break;
        case 2:
          message.count = reader.int32();
          break;
        case 3:
          message.price = reader.float();
          break;
        case 4:
          message.label = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UintFilter {
    return {
      value: isSet(object.value) ? Number(object.value) : 0,
      count: isSet(object.count) ? Number(object.count) : 0,
      price: isSet(object.price) ? Number(object.price) : 0,
      label: isSet(object.label) ? String(object.label) : "",
    };
  },

  toJSON(message: UintFilter): unknown {
    const obj: any = {};
    message.value !== undefined && (obj.value = Math.round(message.value));
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.price !== undefined && (obj.price = message.price);
    message.label !== undefined && (obj.label = message.label);
    return obj;
  },

  fromPartial(object: DeepPartial<UintFilter>): UintFilter {
    const message = createBaseUintFilter();
    message.value = object.value ?? 0;
    message.count = object.count ?? 0;
    message.price = object.price ?? 0;
    message.label = object.label ?? "";
    return message;
  },
};

function createBaseFilterItems(): FilterItems {
  return {
    actionAndFun: undefined,
    adultsOnly: undefined,
    ayurveda: undefined,
    babyCot: undefined,
    babyEquipment: undefined,
    babySitting: undefined,
    beautyFarm: undefined,
    buggyRent: undefined,
    cancellationOption: undefined,
    cancellationCost: undefined,
    cancellationShortlyBefore: undefined,
    centralLocation: undefined,
    charmFlair: undefined,
    childFriendly: undefined,
    childrenBuffet: undefined,
    childrenPlayground: undefined,
    childrenPlayroom: undefined,
    childrenPool: undefined,
    cityBreaks: undefined,
    club: undefined,
    cosmetic: undefined,
    culinaryDelights: undefined,
    cycling: undefined,
    deluxe: undefined,
    directBeachAccess: undefined,
    directFlight: undefined,
    diving: undefined,
    familyHoliday: undefined,
    fitness: undefined,
    flexBooking: undefined,
    freeParking: undefined,
    freeWlan: undefined,
    gentlySlopingSandyBeach: undefined,
    germanSpeakingEntertainmentForKids: undefined,
    golf: undefined,
    greatSportsOffer: undefined,
    handicappedAccessible: undefined,
    heatedPool: undefined,
    hiking: undefined,
    holidayForTwo: undefined,
    horseRiding: undefined,
    hotelNearTheBeach: undefined,
    indoorPool: undefined,
    internet: undefined,
    kidsDisco: undefined,
    kiteSurfing: undefined,
    laundryService: undefined,
    longhaultJourney: undefined,
    lowDeposit: undefined,
    luggageIncluded: undefined,
    massages: undefined,
    matchOnlyCheckedAirlines: undefined,
    maxiClub: undefined,
    medicalService: undefined,
    miniClub: undefined,
    niceSmallFamilyRun: undefined,
    nonSmokingHotel: undefined,
    nonSmokingRooms: undefined,
    oceanView: undefined,
    parkingSpacesAvailable: undefined,
    partialOceanView: undefined,
    petsAllowed: undefined,
    pettingZoo: undefined,
    pool: undefined,
    promoDiscount: undefined,
    railAndFly: undefined,
    relaxationOffersForBodyAndSoul: undefined,
    restaurant: undefined,
    sailing: undefined,
    sandyBeach: undefined,
    sauna: undefined,
    singleWithChild: undefined,
    singles: undefined,
    soccerSchool: undefined,
    specialCommission: undefined,
    sportOffersForChildren: undefined,
    squash: undefined,
    surfing: undefined,
    swimSchool: undefined,
    tennis: undefined,
    thalasso: undefined,
    transfer: undefined,
    privateTransfer: undefined,
    vacationAtMediterraneanSea: undefined,
    vacationAtNorthOrBalticSea: undefined,
    vacationInAustria: undefined,
    vacationInGermany: undefined,
    vacationInTheMountains: undefined,
    waterSlide: undefined,
    waterSports: undefined,
    wellness: undefined,
    windSurfing: undefined,
    wingFoiling: undefined,
    winterSports: undefined,
    areaId: [],
    cityId: [],
    hotelCategoryList: [],
    unitIds: [],
    cancellationDaysBeforeTravelStart: [],
    rating: [],
    accommodationType: [],
    accommodationCategoryGroup: [],
    airlineList: [],
    cateringList: [],
    offerPaymentTypeList: [],
    roomType: [],
    touroperator: [],
    destinationAirportList: [],
  };
}

export const FilterItems = {
  encode(
    message: FilterItems,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.actionAndFun !== undefined) {
      BooleanFilter.encode(
        message.actionAndFun,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.adultsOnly !== undefined) {
      BooleanFilter.encode(
        message.adultsOnly,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.ayurveda !== undefined) {
      BooleanFilter.encode(message.ayurveda, writer.uint32(26).fork()).ldelim();
    }
    if (message.babyCot !== undefined) {
      BooleanFilter.encode(message.babyCot, writer.uint32(34).fork()).ldelim();
    }
    if (message.babyEquipment !== undefined) {
      BooleanFilter.encode(
        message.babyEquipment,
        writer.uint32(42).fork()
      ).ldelim();
    }
    if (message.babySitting !== undefined) {
      BooleanFilter.encode(
        message.babySitting,
        writer.uint32(50).fork()
      ).ldelim();
    }
    if (message.beautyFarm !== undefined) {
      BooleanFilter.encode(
        message.beautyFarm,
        writer.uint32(58).fork()
      ).ldelim();
    }
    if (message.buggyRent !== undefined) {
      BooleanFilter.encode(
        message.buggyRent,
        writer.uint32(66).fork()
      ).ldelim();
    }
    if (message.cancellationOption !== undefined) {
      BooleanFilter.encode(
        message.cancellationOption,
        writer.uint32(74).fork()
      ).ldelim();
    }
    if (message.cancellationCost !== undefined) {
      BooleanFilter.encode(
        message.cancellationCost,
        writer.uint32(82).fork()
      ).ldelim();
    }
    if (message.cancellationShortlyBefore !== undefined) {
      BooleanFilter.encode(
        message.cancellationShortlyBefore,
        writer.uint32(90).fork()
      ).ldelim();
    }
    if (message.centralLocation !== undefined) {
      BooleanFilter.encode(
        message.centralLocation,
        writer.uint32(98).fork()
      ).ldelim();
    }
    if (message.charmFlair !== undefined) {
      BooleanFilter.encode(
        message.charmFlair,
        writer.uint32(106).fork()
      ).ldelim();
    }
    if (message.childFriendly !== undefined) {
      BooleanFilter.encode(
        message.childFriendly,
        writer.uint32(114).fork()
      ).ldelim();
    }
    if (message.childrenBuffet !== undefined) {
      BooleanFilter.encode(
        message.childrenBuffet,
        writer.uint32(122).fork()
      ).ldelim();
    }
    if (message.childrenPlayground !== undefined) {
      BooleanFilter.encode(
        message.childrenPlayground,
        writer.uint32(130).fork()
      ).ldelim();
    }
    if (message.childrenPlayroom !== undefined) {
      BooleanFilter.encode(
        message.childrenPlayroom,
        writer.uint32(138).fork()
      ).ldelim();
    }
    if (message.childrenPool !== undefined) {
      BooleanFilter.encode(
        message.childrenPool,
        writer.uint32(146).fork()
      ).ldelim();
    }
    if (message.cityBreaks !== undefined) {
      BooleanFilter.encode(
        message.cityBreaks,
        writer.uint32(154).fork()
      ).ldelim();
    }
    if (message.club !== undefined) {
      BooleanFilter.encode(message.club, writer.uint32(162).fork()).ldelim();
    }
    if (message.cosmetic !== undefined) {
      BooleanFilter.encode(
        message.cosmetic,
        writer.uint32(170).fork()
      ).ldelim();
    }
    if (message.culinaryDelights !== undefined) {
      BooleanFilter.encode(
        message.culinaryDelights,
        writer.uint32(178).fork()
      ).ldelim();
    }
    if (message.cycling !== undefined) {
      BooleanFilter.encode(message.cycling, writer.uint32(186).fork()).ldelim();
    }
    if (message.deluxe !== undefined) {
      BooleanFilter.encode(message.deluxe, writer.uint32(194).fork()).ldelim();
    }
    if (message.directBeachAccess !== undefined) {
      BooleanFilter.encode(
        message.directBeachAccess,
        writer.uint32(202).fork()
      ).ldelim();
    }
    if (message.directFlight !== undefined) {
      BooleanFilter.encode(
        message.directFlight,
        writer.uint32(210).fork()
      ).ldelim();
    }
    if (message.diving !== undefined) {
      BooleanFilter.encode(message.diving, writer.uint32(226).fork()).ldelim();
    }
    if (message.familyHoliday !== undefined) {
      BooleanFilter.encode(
        message.familyHoliday,
        writer.uint32(234).fork()
      ).ldelim();
    }
    if (message.fitness !== undefined) {
      BooleanFilter.encode(message.fitness, writer.uint32(242).fork()).ldelim();
    }
    if (message.flexBooking !== undefined) {
      BooleanFilter.encode(
        message.flexBooking,
        writer.uint32(250).fork()
      ).ldelim();
    }
    if (message.freeParking !== undefined) {
      BooleanFilter.encode(
        message.freeParking,
        writer.uint32(258).fork()
      ).ldelim();
    }
    if (message.freeWlan !== undefined) {
      BooleanFilter.encode(
        message.freeWlan,
        writer.uint32(266).fork()
      ).ldelim();
    }
    if (message.gentlySlopingSandyBeach !== undefined) {
      BooleanFilter.encode(
        message.gentlySlopingSandyBeach,
        writer.uint32(274).fork()
      ).ldelim();
    }
    if (message.germanSpeakingEntertainmentForKids !== undefined) {
      BooleanFilter.encode(
        message.germanSpeakingEntertainmentForKids,
        writer.uint32(282).fork()
      ).ldelim();
    }
    if (message.golf !== undefined) {
      BooleanFilter.encode(message.golf, writer.uint32(290).fork()).ldelim();
    }
    if (message.greatSportsOffer !== undefined) {
      BooleanFilter.encode(
        message.greatSportsOffer,
        writer.uint32(298).fork()
      ).ldelim();
    }
    if (message.handicappedAccessible !== undefined) {
      BooleanFilter.encode(
        message.handicappedAccessible,
        writer.uint32(306).fork()
      ).ldelim();
    }
    if (message.heatedPool !== undefined) {
      BooleanFilter.encode(
        message.heatedPool,
        writer.uint32(314).fork()
      ).ldelim();
    }
    if (message.hiking !== undefined) {
      BooleanFilter.encode(message.hiking, writer.uint32(322).fork()).ldelim();
    }
    if (message.holidayForTwo !== undefined) {
      BooleanFilter.encode(
        message.holidayForTwo,
        writer.uint32(330).fork()
      ).ldelim();
    }
    if (message.horseRiding !== undefined) {
      BooleanFilter.encode(
        message.horseRiding,
        writer.uint32(338).fork()
      ).ldelim();
    }
    if (message.hotelNearTheBeach !== undefined) {
      BooleanFilter.encode(
        message.hotelNearTheBeach,
        writer.uint32(346).fork()
      ).ldelim();
    }
    if (message.indoorPool !== undefined) {
      BooleanFilter.encode(
        message.indoorPool,
        writer.uint32(362).fork()
      ).ldelim();
    }
    if (message.internet !== undefined) {
      BooleanFilter.encode(
        message.internet,
        writer.uint32(370).fork()
      ).ldelim();
    }
    if (message.kidsDisco !== undefined) {
      BooleanFilter.encode(
        message.kidsDisco,
        writer.uint32(378).fork()
      ).ldelim();
    }
    if (message.kiteSurfing !== undefined) {
      BooleanFilter.encode(
        message.kiteSurfing,
        writer.uint32(802).fork()
      ).ldelim();
    }
    if (message.laundryService !== undefined) {
      BooleanFilter.encode(
        message.laundryService,
        writer.uint32(386).fork()
      ).ldelim();
    }
    if (message.longhaultJourney !== undefined) {
      BooleanFilter.encode(
        message.longhaultJourney,
        writer.uint32(394).fork()
      ).ldelim();
    }
    if (message.lowDeposit !== undefined) {
      BooleanFilter.encode(
        message.lowDeposit,
        writer.uint32(402).fork()
      ).ldelim();
    }
    if (message.luggageIncluded !== undefined) {
      BooleanFilter.encode(
        message.luggageIncluded,
        writer.uint32(410).fork()
      ).ldelim();
    }
    if (message.massages !== undefined) {
      BooleanFilter.encode(
        message.massages,
        writer.uint32(418).fork()
      ).ldelim();
    }
    if (message.matchOnlyCheckedAirlines !== undefined) {
      BooleanFilter.encode(
        message.matchOnlyCheckedAirlines,
        writer.uint32(426).fork()
      ).ldelim();
    }
    if (message.maxiClub !== undefined) {
      BooleanFilter.encode(
        message.maxiClub,
        writer.uint32(434).fork()
      ).ldelim();
    }
    if (message.medicalService !== undefined) {
      BooleanFilter.encode(
        message.medicalService,
        writer.uint32(442).fork()
      ).ldelim();
    }
    if (message.miniClub !== undefined) {
      BooleanFilter.encode(
        message.miniClub,
        writer.uint32(450).fork()
      ).ldelim();
    }
    if (message.niceSmallFamilyRun !== undefined) {
      BooleanFilter.encode(
        message.niceSmallFamilyRun,
        writer.uint32(458).fork()
      ).ldelim();
    }
    if (message.nonSmokingHotel !== undefined) {
      BooleanFilter.encode(
        message.nonSmokingHotel,
        writer.uint32(466).fork()
      ).ldelim();
    }
    if (message.nonSmokingRooms !== undefined) {
      BooleanFilter.encode(
        message.nonSmokingRooms,
        writer.uint32(474).fork()
      ).ldelim();
    }
    if (message.oceanView !== undefined) {
      BooleanFilter.encode(
        message.oceanView,
        writer.uint32(482).fork()
      ).ldelim();
    }
    if (message.parkingSpacesAvailable !== undefined) {
      BooleanFilter.encode(
        message.parkingSpacesAvailable,
        writer.uint32(490).fork()
      ).ldelim();
    }
    if (message.partialOceanView !== undefined) {
      BooleanFilter.encode(
        message.partialOceanView,
        writer.uint32(498).fork()
      ).ldelim();
    }
    if (message.petsAllowed !== undefined) {
      BooleanFilter.encode(
        message.petsAllowed,
        writer.uint32(506).fork()
      ).ldelim();
    }
    if (message.pettingZoo !== undefined) {
      BooleanFilter.encode(
        message.pettingZoo,
        writer.uint32(514).fork()
      ).ldelim();
    }
    if (message.pool !== undefined) {
      BooleanFilter.encode(message.pool, writer.uint32(522).fork()).ldelim();
    }
    if (message.promoDiscount !== undefined) {
      BooleanFilter.encode(
        message.promoDiscount,
        writer.uint32(538).fork()
      ).ldelim();
    }
    if (message.railAndFly !== undefined) {
      BooleanFilter.encode(
        message.railAndFly,
        writer.uint32(546).fork()
      ).ldelim();
    }
    if (message.relaxationOffersForBodyAndSoul !== undefined) {
      BooleanFilter.encode(
        message.relaxationOffersForBodyAndSoul,
        writer.uint32(554).fork()
      ).ldelim();
    }
    if (message.restaurant !== undefined) {
      BooleanFilter.encode(
        message.restaurant,
        writer.uint32(562).fork()
      ).ldelim();
    }
    if (message.sailing !== undefined) {
      BooleanFilter.encode(message.sailing, writer.uint32(570).fork()).ldelim();
    }
    if (message.sandyBeach !== undefined) {
      BooleanFilter.encode(
        message.sandyBeach,
        writer.uint32(578).fork()
      ).ldelim();
    }
    if (message.sauna !== undefined) {
      BooleanFilter.encode(message.sauna, writer.uint32(586).fork()).ldelim();
    }
    if (message.singleWithChild !== undefined) {
      BooleanFilter.encode(
        message.singleWithChild,
        writer.uint32(594).fork()
      ).ldelim();
    }
    if (message.singles !== undefined) {
      BooleanFilter.encode(message.singles, writer.uint32(602).fork()).ldelim();
    }
    if (message.soccerSchool !== undefined) {
      BooleanFilter.encode(
        message.soccerSchool,
        writer.uint32(610).fork()
      ).ldelim();
    }
    if (message.specialCommission !== undefined) {
      BooleanFilter.encode(
        message.specialCommission,
        writer.uint32(626).fork()
      ).ldelim();
    }
    if (message.sportOffersForChildren !== undefined) {
      BooleanFilter.encode(
        message.sportOffersForChildren,
        writer.uint32(634).fork()
      ).ldelim();
    }
    if (message.squash !== undefined) {
      BooleanFilter.encode(message.squash, writer.uint32(642).fork()).ldelim();
    }
    if (message.surfing !== undefined) {
      BooleanFilter.encode(message.surfing, writer.uint32(650).fork()).ldelim();
    }
    if (message.swimSchool !== undefined) {
      BooleanFilter.encode(
        message.swimSchool,
        writer.uint32(658).fork()
      ).ldelim();
    }
    if (message.tennis !== undefined) {
      BooleanFilter.encode(message.tennis, writer.uint32(666).fork()).ldelim();
    }
    if (message.thalasso !== undefined) {
      BooleanFilter.encode(
        message.thalasso,
        writer.uint32(674).fork()
      ).ldelim();
    }
    if (message.transfer !== undefined) {
      BooleanFilter.encode(
        message.transfer,
        writer.uint32(690).fork()
      ).ldelim();
    }
    if (message.privateTransfer !== undefined) {
      BooleanFilter.encode(
        message.privateTransfer,
        writer.uint32(962).fork()
      ).ldelim();
    }
    if (message.vacationAtMediterraneanSea !== undefined) {
      BooleanFilter.encode(
        message.vacationAtMediterraneanSea,
        writer.uint32(698).fork()
      ).ldelim();
    }
    if (message.vacationAtNorthOrBalticSea !== undefined) {
      BooleanFilter.encode(
        message.vacationAtNorthOrBalticSea,
        writer.uint32(706).fork()
      ).ldelim();
    }
    if (message.vacationInAustria !== undefined) {
      BooleanFilter.encode(
        message.vacationInAustria,
        writer.uint32(714).fork()
      ).ldelim();
    }
    if (message.vacationInGermany !== undefined) {
      BooleanFilter.encode(
        message.vacationInGermany,
        writer.uint32(722).fork()
      ).ldelim();
    }
    if (message.vacationInTheMountains !== undefined) {
      BooleanFilter.encode(
        message.vacationInTheMountains,
        writer.uint32(730).fork()
      ).ldelim();
    }
    if (message.waterSlide !== undefined) {
      BooleanFilter.encode(
        message.waterSlide,
        writer.uint32(738).fork()
      ).ldelim();
    }
    if (message.waterSports !== undefined) {
      BooleanFilter.encode(
        message.waterSports,
        writer.uint32(746).fork()
      ).ldelim();
    }
    if (message.wellness !== undefined) {
      BooleanFilter.encode(
        message.wellness,
        writer.uint32(754).fork()
      ).ldelim();
    }
    if (message.windSurfing !== undefined) {
      BooleanFilter.encode(
        message.windSurfing,
        writer.uint32(810).fork()
      ).ldelim();
    }
    if (message.wingFoiling !== undefined) {
      BooleanFilter.encode(
        message.wingFoiling,
        writer.uint32(978).fork()
      ).ldelim();
    }
    if (message.winterSports !== undefined) {
      BooleanFilter.encode(
        message.winterSports,
        writer.uint32(762).fork()
      ).ldelim();
    }
    for (const v of message.areaId) {
      UintFilter.encode(v!, writer.uint32(770).fork()).ldelim();
    }
    for (const v of message.cityId) {
      UintFilter.encode(v!, writer.uint32(778).fork()).ldelim();
    }
    for (const v of message.hotelCategoryList) {
      UintFilter.encode(v!, writer.uint32(786).fork()).ldelim();
    }
    for (const v of message.unitIds) {
      UintFilter.encode(v!, writer.uint32(882).fork()).ldelim();
    }
    for (const v of message.cancellationDaysBeforeTravelStart) {
      UintFilter.encode(v!, writer.uint32(954).fork()).ldelim();
    }
    for (const v of message.rating) {
      FloatFilter.encode(v!, writer.uint32(890).fork()).ldelim();
    }
    for (const v of message.accommodationType) {
      StringFilter.encode(v!, writer.uint32(898).fork()).ldelim();
    }
    for (const v of message.accommodationCategoryGroup) {
      StringFilter.encode(v!, writer.uint32(970).fork()).ldelim();
    }
    for (const v of message.airlineList) {
      StringFilter.encode(v!, writer.uint32(906).fork()).ldelim();
    }
    for (const v of message.cateringList) {
      StringFilter.encode(v!, writer.uint32(914).fork()).ldelim();
    }
    for (const v of message.offerPaymentTypeList) {
      StringFilter.encode(v!, writer.uint32(922).fork()).ldelim();
    }
    for (const v of message.roomType) {
      StringFilter.encode(v!, writer.uint32(930).fork()).ldelim();
    }
    for (const v of message.touroperator) {
      StringFilter.encode(v!, writer.uint32(938).fork()).ldelim();
    }
    for (const v of message.destinationAirportList) {
      AirportFilter.encode(v!, writer.uint32(946).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FilterItems {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilterItems();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.actionAndFun = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 2:
          message.adultsOnly = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 3:
          message.ayurveda = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 4:
          message.babyCot = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 5:
          message.babyEquipment = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 6:
          message.babySitting = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 7:
          message.beautyFarm = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 8:
          message.buggyRent = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 9:
          message.cancellationOption = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 10:
          message.cancellationCost = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 11:
          message.cancellationShortlyBefore = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 12:
          message.centralLocation = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 13:
          message.charmFlair = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 14:
          message.childFriendly = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 15:
          message.childrenBuffet = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 16:
          message.childrenPlayground = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 17:
          message.childrenPlayroom = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 18:
          message.childrenPool = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 19:
          message.cityBreaks = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 20:
          message.club = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 21:
          message.cosmetic = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 22:
          message.culinaryDelights = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 23:
          message.cycling = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 24:
          message.deluxe = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 25:
          message.directBeachAccess = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 26:
          message.directFlight = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 28:
          message.diving = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 29:
          message.familyHoliday = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 30:
          message.fitness = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 31:
          message.flexBooking = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 32:
          message.freeParking = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 33:
          message.freeWlan = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 34:
          message.gentlySlopingSandyBeach = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 35:
          message.germanSpeakingEntertainmentForKids = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 36:
          message.golf = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 37:
          message.greatSportsOffer = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 38:
          message.handicappedAccessible = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 39:
          message.heatedPool = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 40:
          message.hiking = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 41:
          message.holidayForTwo = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 42:
          message.horseRiding = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 43:
          message.hotelNearTheBeach = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 45:
          message.indoorPool = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 46:
          message.internet = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 47:
          message.kidsDisco = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 100:
          message.kiteSurfing = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 48:
          message.laundryService = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 49:
          message.longhaultJourney = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 50:
          message.lowDeposit = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 51:
          message.luggageIncluded = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 52:
          message.massages = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 53:
          message.matchOnlyCheckedAirlines = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 54:
          message.maxiClub = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 55:
          message.medicalService = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 56:
          message.miniClub = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 57:
          message.niceSmallFamilyRun = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 58:
          message.nonSmokingHotel = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 59:
          message.nonSmokingRooms = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 60:
          message.oceanView = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 61:
          message.parkingSpacesAvailable = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 62:
          message.partialOceanView = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 63:
          message.petsAllowed = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 64:
          message.pettingZoo = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 65:
          message.pool = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 67:
          message.promoDiscount = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 68:
          message.railAndFly = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 69:
          message.relaxationOffersForBodyAndSoul = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 70:
          message.restaurant = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 71:
          message.sailing = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 72:
          message.sandyBeach = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 73:
          message.sauna = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 74:
          message.singleWithChild = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 75:
          message.singles = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 76:
          message.soccerSchool = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 78:
          message.specialCommission = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 79:
          message.sportOffersForChildren = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 80:
          message.squash = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 81:
          message.surfing = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 82:
          message.swimSchool = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 83:
          message.tennis = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 84:
          message.thalasso = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 86:
          message.transfer = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 120:
          message.privateTransfer = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 87:
          message.vacationAtMediterraneanSea = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 88:
          message.vacationAtNorthOrBalticSea = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 89:
          message.vacationInAustria = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 90:
          message.vacationInGermany = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 91:
          message.vacationInTheMountains = BooleanFilter.decode(
            reader,
            reader.uint32()
          );
          break;
        case 92:
          message.waterSlide = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 93:
          message.waterSports = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 94:
          message.wellness = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 101:
          message.windSurfing = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 122:
          message.wingFoiling = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 95:
          message.winterSports = BooleanFilter.decode(reader, reader.uint32());
          break;
        case 96:
          message.areaId.push(UintFilter.decode(reader, reader.uint32()));
          break;
        case 97:
          message.cityId.push(UintFilter.decode(reader, reader.uint32()));
          break;
        case 98:
          message.hotelCategoryList.push(
            UintFilter.decode(reader, reader.uint32())
          );
          break;
        case 110:
          message.unitIds.push(UintFilter.decode(reader, reader.uint32()));
          break;
        case 119:
          message.cancellationDaysBeforeTravelStart.push(
            UintFilter.decode(reader, reader.uint32())
          );
          break;
        case 111:
          message.rating.push(FloatFilter.decode(reader, reader.uint32()));
          break;
        case 112:
          message.accommodationType.push(
            StringFilter.decode(reader, reader.uint32())
          );
          break;
        case 121:
          message.accommodationCategoryGroup.push(
            StringFilter.decode(reader, reader.uint32())
          );
          break;
        case 113:
          message.airlineList.push(
            StringFilter.decode(reader, reader.uint32())
          );
          break;
        case 114:
          message.cateringList.push(
            StringFilter.decode(reader, reader.uint32())
          );
          break;
        case 115:
          message.offerPaymentTypeList.push(
            StringFilter.decode(reader, reader.uint32())
          );
          break;
        case 116:
          message.roomType.push(StringFilter.decode(reader, reader.uint32()));
          break;
        case 117:
          message.touroperator.push(
            StringFilter.decode(reader, reader.uint32())
          );
          break;
        case 118:
          message.destinationAirportList.push(
            AirportFilter.decode(reader, reader.uint32())
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FilterItems {
    return {
      actionAndFun: isSet(object.actionAndFun)
        ? BooleanFilter.fromJSON(object.actionAndFun)
        : undefined,
      adultsOnly: isSet(object.adultsOnly)
        ? BooleanFilter.fromJSON(object.adultsOnly)
        : undefined,
      ayurveda: isSet(object.ayurveda)
        ? BooleanFilter.fromJSON(object.ayurveda)
        : undefined,
      babyCot: isSet(object.babyCot)
        ? BooleanFilter.fromJSON(object.babyCot)
        : undefined,
      babyEquipment: isSet(object.babyEquipment)
        ? BooleanFilter.fromJSON(object.babyEquipment)
        : undefined,
      babySitting: isSet(object.babySitting)
        ? BooleanFilter.fromJSON(object.babySitting)
        : undefined,
      beautyFarm: isSet(object.beautyFarm)
        ? BooleanFilter.fromJSON(object.beautyFarm)
        : undefined,
      buggyRent: isSet(object.buggyRent)
        ? BooleanFilter.fromJSON(object.buggyRent)
        : undefined,
      cancellationOption: isSet(object.cancellationOption)
        ? BooleanFilter.fromJSON(object.cancellationOption)
        : undefined,
      cancellationCost: isSet(object.cancellationCost)
        ? BooleanFilter.fromJSON(object.cancellationCost)
        : undefined,
      cancellationShortlyBefore: isSet(object.cancellationShortlyBefore)
        ? BooleanFilter.fromJSON(object.cancellationShortlyBefore)
        : undefined,
      centralLocation: isSet(object.centralLocation)
        ? BooleanFilter.fromJSON(object.centralLocation)
        : undefined,
      charmFlair: isSet(object.charmFlair)
        ? BooleanFilter.fromJSON(object.charmFlair)
        : undefined,
      childFriendly: isSet(object.childFriendly)
        ? BooleanFilter.fromJSON(object.childFriendly)
        : undefined,
      childrenBuffet: isSet(object.childrenBuffet)
        ? BooleanFilter.fromJSON(object.childrenBuffet)
        : undefined,
      childrenPlayground: isSet(object.childrenPlayground)
        ? BooleanFilter.fromJSON(object.childrenPlayground)
        : undefined,
      childrenPlayroom: isSet(object.childrenPlayroom)
        ? BooleanFilter.fromJSON(object.childrenPlayroom)
        : undefined,
      childrenPool: isSet(object.childrenPool)
        ? BooleanFilter.fromJSON(object.childrenPool)
        : undefined,
      cityBreaks: isSet(object.cityBreaks)
        ? BooleanFilter.fromJSON(object.cityBreaks)
        : undefined,
      club: isSet(object.club)
        ? BooleanFilter.fromJSON(object.club)
        : undefined,
      cosmetic: isSet(object.cosmetic)
        ? BooleanFilter.fromJSON(object.cosmetic)
        : undefined,
      culinaryDelights: isSet(object.culinaryDelights)
        ? BooleanFilter.fromJSON(object.culinaryDelights)
        : undefined,
      cycling: isSet(object.cycling)
        ? BooleanFilter.fromJSON(object.cycling)
        : undefined,
      deluxe: isSet(object.deluxe)
        ? BooleanFilter.fromJSON(object.deluxe)
        : undefined,
      directBeachAccess: isSet(object.directBeachAccess)
        ? BooleanFilter.fromJSON(object.directBeachAccess)
        : undefined,
      directFlight: isSet(object.directFlight)
        ? BooleanFilter.fromJSON(object.directFlight)
        : undefined,
      diving: isSet(object.diving)
        ? BooleanFilter.fromJSON(object.diving)
        : undefined,
      familyHoliday: isSet(object.familyHoliday)
        ? BooleanFilter.fromJSON(object.familyHoliday)
        : undefined,
      fitness: isSet(object.fitness)
        ? BooleanFilter.fromJSON(object.fitness)
        : undefined,
      flexBooking: isSet(object.flexBooking)
        ? BooleanFilter.fromJSON(object.flexBooking)
        : undefined,
      freeParking: isSet(object.freeParking)
        ? BooleanFilter.fromJSON(object.freeParking)
        : undefined,
      freeWlan: isSet(object.freeWlan)
        ? BooleanFilter.fromJSON(object.freeWlan)
        : undefined,
      gentlySlopingSandyBeach: isSet(object.gentlySlopingSandyBeach)
        ? BooleanFilter.fromJSON(object.gentlySlopingSandyBeach)
        : undefined,
      germanSpeakingEntertainmentForKids: isSet(
        object.germanSpeakingEntertainmentForKids
      )
        ? BooleanFilter.fromJSON(object.germanSpeakingEntertainmentForKids)
        : undefined,
      golf: isSet(object.golf)
        ? BooleanFilter.fromJSON(object.golf)
        : undefined,
      greatSportsOffer: isSet(object.greatSportsOffer)
        ? BooleanFilter.fromJSON(object.greatSportsOffer)
        : undefined,
      handicappedAccessible: isSet(object.handicappedAccessible)
        ? BooleanFilter.fromJSON(object.handicappedAccessible)
        : undefined,
      heatedPool: isSet(object.heatedPool)
        ? BooleanFilter.fromJSON(object.heatedPool)
        : undefined,
      hiking: isSet(object.hiking)
        ? BooleanFilter.fromJSON(object.hiking)
        : undefined,
      holidayForTwo: isSet(object.holidayForTwo)
        ? BooleanFilter.fromJSON(object.holidayForTwo)
        : undefined,
      horseRiding: isSet(object.horseRiding)
        ? BooleanFilter.fromJSON(object.horseRiding)
        : undefined,
      hotelNearTheBeach: isSet(object.hotelNearTheBeach)
        ? BooleanFilter.fromJSON(object.hotelNearTheBeach)
        : undefined,
      indoorPool: isSet(object.indoorPool)
        ? BooleanFilter.fromJSON(object.indoorPool)
        : undefined,
      internet: isSet(object.internet)
        ? BooleanFilter.fromJSON(object.internet)
        : undefined,
      kidsDisco: isSet(object.kidsDisco)
        ? BooleanFilter.fromJSON(object.kidsDisco)
        : undefined,
      kiteSurfing: isSet(object.kiteSurfing)
        ? BooleanFilter.fromJSON(object.kiteSurfing)
        : undefined,
      laundryService: isSet(object.laundryService)
        ? BooleanFilter.fromJSON(object.laundryService)
        : undefined,
      longhaultJourney: isSet(object.longhaultJourney)
        ? BooleanFilter.fromJSON(object.longhaultJourney)
        : undefined,
      lowDeposit: isSet(object.lowDeposit)
        ? BooleanFilter.fromJSON(object.lowDeposit)
        : undefined,
      luggageIncluded: isSet(object.luggageIncluded)
        ? BooleanFilter.fromJSON(object.luggageIncluded)
        : undefined,
      massages: isSet(object.massages)
        ? BooleanFilter.fromJSON(object.massages)
        : undefined,
      matchOnlyCheckedAirlines: isSet(object.matchOnlyCheckedAirlines)
        ? BooleanFilter.fromJSON(object.matchOnlyCheckedAirlines)
        : undefined,
      maxiClub: isSet(object.maxiClub)
        ? BooleanFilter.fromJSON(object.maxiClub)
        : undefined,
      medicalService: isSet(object.medicalService)
        ? BooleanFilter.fromJSON(object.medicalService)
        : undefined,
      miniClub: isSet(object.miniClub)
        ? BooleanFilter.fromJSON(object.miniClub)
        : undefined,
      niceSmallFamilyRun: isSet(object.niceSmallFamilyRun)
        ? BooleanFilter.fromJSON(object.niceSmallFamilyRun)
        : undefined,
      nonSmokingHotel: isSet(object.nonSmokingHotel)
        ? BooleanFilter.fromJSON(object.nonSmokingHotel)
        : undefined,
      nonSmokingRooms: isSet(object.nonSmokingRooms)
        ? BooleanFilter.fromJSON(object.nonSmokingRooms)
        : undefined,
      oceanView: isSet(object.oceanView)
        ? BooleanFilter.fromJSON(object.oceanView)
        : undefined,
      parkingSpacesAvailable: isSet(object.parkingSpacesAvailable)
        ? BooleanFilter.fromJSON(object.parkingSpacesAvailable)
        : undefined,
      partialOceanView: isSet(object.partialOceanView)
        ? BooleanFilter.fromJSON(object.partialOceanView)
        : undefined,
      petsAllowed: isSet(object.petsAllowed)
        ? BooleanFilter.fromJSON(object.petsAllowed)
        : undefined,
      pettingZoo: isSet(object.pettingZoo)
        ? BooleanFilter.fromJSON(object.pettingZoo)
        : undefined,
      pool: isSet(object.pool)
        ? BooleanFilter.fromJSON(object.pool)
        : undefined,
      promoDiscount: isSet(object.promoDiscount)
        ? BooleanFilter.fromJSON(object.promoDiscount)
        : undefined,
      railAndFly: isSet(object.railAndFly)
        ? BooleanFilter.fromJSON(object.railAndFly)
        : undefined,
      relaxationOffersForBodyAndSoul: isSet(
        object.relaxationOffersForBodyAndSoul
      )
        ? BooleanFilter.fromJSON(object.relaxationOffersForBodyAndSoul)
        : undefined,
      restaurant: isSet(object.restaurant)
        ? BooleanFilter.fromJSON(object.restaurant)
        : undefined,
      sailing: isSet(object.sailing)
        ? BooleanFilter.fromJSON(object.sailing)
        : undefined,
      sandyBeach: isSet(object.sandyBeach)
        ? BooleanFilter.fromJSON(object.sandyBeach)
        : undefined,
      sauna: isSet(object.sauna)
        ? BooleanFilter.fromJSON(object.sauna)
        : undefined,
      singleWithChild: isSet(object.singleWithChild)
        ? BooleanFilter.fromJSON(object.singleWithChild)
        : undefined,
      singles: isSet(object.singles)
        ? BooleanFilter.fromJSON(object.singles)
        : undefined,
      soccerSchool: isSet(object.soccerSchool)
        ? BooleanFilter.fromJSON(object.soccerSchool)
        : undefined,
      specialCommission: isSet(object.specialCommission)
        ? BooleanFilter.fromJSON(object.specialCommission)
        : undefined,
      sportOffersForChildren: isSet(object.sportOffersForChildren)
        ? BooleanFilter.fromJSON(object.sportOffersForChildren)
        : undefined,
      squash: isSet(object.squash)
        ? BooleanFilter.fromJSON(object.squash)
        : undefined,
      surfing: isSet(object.surfing)
        ? BooleanFilter.fromJSON(object.surfing)
        : undefined,
      swimSchool: isSet(object.swimSchool)
        ? BooleanFilter.fromJSON(object.swimSchool)
        : undefined,
      tennis: isSet(object.tennis)
        ? BooleanFilter.fromJSON(object.tennis)
        : undefined,
      thalasso: isSet(object.thalasso)
        ? BooleanFilter.fromJSON(object.thalasso)
        : undefined,
      transfer: isSet(object.transfer)
        ? BooleanFilter.fromJSON(object.transfer)
        : undefined,
      privateTransfer: isSet(object.privateTransfer)
        ? BooleanFilter.fromJSON(object.privateTransfer)
        : undefined,
      vacationAtMediterraneanSea: isSet(object.vacationAtMediterraneanSea)
        ? BooleanFilter.fromJSON(object.vacationAtMediterraneanSea)
        : undefined,
      vacationAtNorthOrBalticSea: isSet(object.vacationAtNorthOrBalticSea)
        ? BooleanFilter.fromJSON(object.vacationAtNorthOrBalticSea)
        : undefined,
      vacationInAustria: isSet(object.vacationInAustria)
        ? BooleanFilter.fromJSON(object.vacationInAustria)
        : undefined,
      vacationInGermany: isSet(object.vacationInGermany)
        ? BooleanFilter.fromJSON(object.vacationInGermany)
        : undefined,
      vacationInTheMountains: isSet(object.vacationInTheMountains)
        ? BooleanFilter.fromJSON(object.vacationInTheMountains)
        : undefined,
      waterSlide: isSet(object.waterSlide)
        ? BooleanFilter.fromJSON(object.waterSlide)
        : undefined,
      waterSports: isSet(object.waterSports)
        ? BooleanFilter.fromJSON(object.waterSports)
        : undefined,
      wellness: isSet(object.wellness)
        ? BooleanFilter.fromJSON(object.wellness)
        : undefined,
      windSurfing: isSet(object.windSurfing)
        ? BooleanFilter.fromJSON(object.windSurfing)
        : undefined,
      wingFoiling: isSet(object.wingFoiling)
        ? BooleanFilter.fromJSON(object.wingFoiling)
        : undefined,
      winterSports: isSet(object.winterSports)
        ? BooleanFilter.fromJSON(object.winterSports)
        : undefined,
      areaId: Array.isArray(object?.areaId)
        ? object.areaId.map((e: any) => UintFilter.fromJSON(e))
        : [],
      cityId: Array.isArray(object?.cityId)
        ? object.cityId.map((e: any) => UintFilter.fromJSON(e))
        : [],
      hotelCategoryList: Array.isArray(object?.hotelCategoryList)
        ? object.hotelCategoryList.map((e: any) => UintFilter.fromJSON(e))
        : [],
      unitIds: Array.isArray(object?.unitIds)
        ? object.unitIds.map((e: any) => UintFilter.fromJSON(e))
        : [],
      cancellationDaysBeforeTravelStart: Array.isArray(
        object?.cancellationDaysBeforeTravelStart
      )
        ? object.cancellationDaysBeforeTravelStart.map((e: any) =>
            UintFilter.fromJSON(e)
          )
        : [],
      rating: Array.isArray(object?.rating)
        ? object.rating.map((e: any) => FloatFilter.fromJSON(e))
        : [],
      accommodationType: Array.isArray(object?.accommodationType)
        ? object.accommodationType.map((e: any) => StringFilter.fromJSON(e))
        : [],
      accommodationCategoryGroup: Array.isArray(
        object?.accommodationCategoryGroup
      )
        ? object.accommodationCategoryGroup.map((e: any) =>
            StringFilter.fromJSON(e)
          )
        : [],
      airlineList: Array.isArray(object?.airlineList)
        ? object.airlineList.map((e: any) => StringFilter.fromJSON(e))
        : [],
      cateringList: Array.isArray(object?.cateringList)
        ? object.cateringList.map((e: any) => StringFilter.fromJSON(e))
        : [],
      offerPaymentTypeList: Array.isArray(object?.offerPaymentTypeList)
        ? object.offerPaymentTypeList.map((e: any) => StringFilter.fromJSON(e))
        : [],
      roomType: Array.isArray(object?.roomType)
        ? object.roomType.map((e: any) => StringFilter.fromJSON(e))
        : [],
      touroperator: Array.isArray(object?.touroperator)
        ? object.touroperator.map((e: any) => StringFilter.fromJSON(e))
        : [],
      destinationAirportList: Array.isArray(object?.destinationAirportList)
        ? object.destinationAirportList.map((e: any) =>
            AirportFilter.fromJSON(e)
          )
        : [],
    };
  },

  toJSON(message: FilterItems): unknown {
    const obj: any = {};
    message.actionAndFun !== undefined &&
      (obj.actionAndFun = message.actionAndFun
        ? BooleanFilter.toJSON(message.actionAndFun)
        : undefined);
    message.adultsOnly !== undefined &&
      (obj.adultsOnly = message.adultsOnly
        ? BooleanFilter.toJSON(message.adultsOnly)
        : undefined);
    message.ayurveda !== undefined &&
      (obj.ayurveda = message.ayurveda
        ? BooleanFilter.toJSON(message.ayurveda)
        : undefined);
    message.babyCot !== undefined &&
      (obj.babyCot = message.babyCot
        ? BooleanFilter.toJSON(message.babyCot)
        : undefined);
    message.babyEquipment !== undefined &&
      (obj.babyEquipment = message.babyEquipment
        ? BooleanFilter.toJSON(message.babyEquipment)
        : undefined);
    message.babySitting !== undefined &&
      (obj.babySitting = message.babySitting
        ? BooleanFilter.toJSON(message.babySitting)
        : undefined);
    message.beautyFarm !== undefined &&
      (obj.beautyFarm = message.beautyFarm
        ? BooleanFilter.toJSON(message.beautyFarm)
        : undefined);
    message.buggyRent !== undefined &&
      (obj.buggyRent = message.buggyRent
        ? BooleanFilter.toJSON(message.buggyRent)
        : undefined);
    message.cancellationOption !== undefined &&
      (obj.cancellationOption = message.cancellationOption
        ? BooleanFilter.toJSON(message.cancellationOption)
        : undefined);
    message.cancellationCost !== undefined &&
      (obj.cancellationCost = message.cancellationCost
        ? BooleanFilter.toJSON(message.cancellationCost)
        : undefined);
    message.cancellationShortlyBefore !== undefined &&
      (obj.cancellationShortlyBefore = message.cancellationShortlyBefore
        ? BooleanFilter.toJSON(message.cancellationShortlyBefore)
        : undefined);
    message.centralLocation !== undefined &&
      (obj.centralLocation = message.centralLocation
        ? BooleanFilter.toJSON(message.centralLocation)
        : undefined);
    message.charmFlair !== undefined &&
      (obj.charmFlair = message.charmFlair
        ? BooleanFilter.toJSON(message.charmFlair)
        : undefined);
    message.childFriendly !== undefined &&
      (obj.childFriendly = message.childFriendly
        ? BooleanFilter.toJSON(message.childFriendly)
        : undefined);
    message.childrenBuffet !== undefined &&
      (obj.childrenBuffet = message.childrenBuffet
        ? BooleanFilter.toJSON(message.childrenBuffet)
        : undefined);
    message.childrenPlayground !== undefined &&
      (obj.childrenPlayground = message.childrenPlayground
        ? BooleanFilter.toJSON(message.childrenPlayground)
        : undefined);
    message.childrenPlayroom !== undefined &&
      (obj.childrenPlayroom = message.childrenPlayroom
        ? BooleanFilter.toJSON(message.childrenPlayroom)
        : undefined);
    message.childrenPool !== undefined &&
      (obj.childrenPool = message.childrenPool
        ? BooleanFilter.toJSON(message.childrenPool)
        : undefined);
    message.cityBreaks !== undefined &&
      (obj.cityBreaks = message.cityBreaks
        ? BooleanFilter.toJSON(message.cityBreaks)
        : undefined);
    message.club !== undefined &&
      (obj.club = message.club
        ? BooleanFilter.toJSON(message.club)
        : undefined);
    message.cosmetic !== undefined &&
      (obj.cosmetic = message.cosmetic
        ? BooleanFilter.toJSON(message.cosmetic)
        : undefined);
    message.culinaryDelights !== undefined &&
      (obj.culinaryDelights = message.culinaryDelights
        ? BooleanFilter.toJSON(message.culinaryDelights)
        : undefined);
    message.cycling !== undefined &&
      (obj.cycling = message.cycling
        ? BooleanFilter.toJSON(message.cycling)
        : undefined);
    message.deluxe !== undefined &&
      (obj.deluxe = message.deluxe
        ? BooleanFilter.toJSON(message.deluxe)
        : undefined);
    message.directBeachAccess !== undefined &&
      (obj.directBeachAccess = message.directBeachAccess
        ? BooleanFilter.toJSON(message.directBeachAccess)
        : undefined);
    message.directFlight !== undefined &&
      (obj.directFlight = message.directFlight
        ? BooleanFilter.toJSON(message.directFlight)
        : undefined);
    message.diving !== undefined &&
      (obj.diving = message.diving
        ? BooleanFilter.toJSON(message.diving)
        : undefined);
    message.familyHoliday !== undefined &&
      (obj.familyHoliday = message.familyHoliday
        ? BooleanFilter.toJSON(message.familyHoliday)
        : undefined);
    message.fitness !== undefined &&
      (obj.fitness = message.fitness
        ? BooleanFilter.toJSON(message.fitness)
        : undefined);
    message.flexBooking !== undefined &&
      (obj.flexBooking = message.flexBooking
        ? BooleanFilter.toJSON(message.flexBooking)
        : undefined);
    message.freeParking !== undefined &&
      (obj.freeParking = message.freeParking
        ? BooleanFilter.toJSON(message.freeParking)
        : undefined);
    message.freeWlan !== undefined &&
      (obj.freeWlan = message.freeWlan
        ? BooleanFilter.toJSON(message.freeWlan)
        : undefined);
    message.gentlySlopingSandyBeach !== undefined &&
      (obj.gentlySlopingSandyBeach = message.gentlySlopingSandyBeach
        ? BooleanFilter.toJSON(message.gentlySlopingSandyBeach)
        : undefined);
    message.germanSpeakingEntertainmentForKids !== undefined &&
      (obj.germanSpeakingEntertainmentForKids =
        message.germanSpeakingEntertainmentForKids
          ? BooleanFilter.toJSON(message.germanSpeakingEntertainmentForKids)
          : undefined);
    message.golf !== undefined &&
      (obj.golf = message.golf
        ? BooleanFilter.toJSON(message.golf)
        : undefined);
    message.greatSportsOffer !== undefined &&
      (obj.greatSportsOffer = message.greatSportsOffer
        ? BooleanFilter.toJSON(message.greatSportsOffer)
        : undefined);
    message.handicappedAccessible !== undefined &&
      (obj.handicappedAccessible = message.handicappedAccessible
        ? BooleanFilter.toJSON(message.handicappedAccessible)
        : undefined);
    message.heatedPool !== undefined &&
      (obj.heatedPool = message.heatedPool
        ? BooleanFilter.toJSON(message.heatedPool)
        : undefined);
    message.hiking !== undefined &&
      (obj.hiking = message.hiking
        ? BooleanFilter.toJSON(message.hiking)
        : undefined);
    message.holidayForTwo !== undefined &&
      (obj.holidayForTwo = message.holidayForTwo
        ? BooleanFilter.toJSON(message.holidayForTwo)
        : undefined);
    message.horseRiding !== undefined &&
      (obj.horseRiding = message.horseRiding
        ? BooleanFilter.toJSON(message.horseRiding)
        : undefined);
    message.hotelNearTheBeach !== undefined &&
      (obj.hotelNearTheBeach = message.hotelNearTheBeach
        ? BooleanFilter.toJSON(message.hotelNearTheBeach)
        : undefined);
    message.indoorPool !== undefined &&
      (obj.indoorPool = message.indoorPool
        ? BooleanFilter.toJSON(message.indoorPool)
        : undefined);
    message.internet !== undefined &&
      (obj.internet = message.internet
        ? BooleanFilter.toJSON(message.internet)
        : undefined);
    message.kidsDisco !== undefined &&
      (obj.kidsDisco = message.kidsDisco
        ? BooleanFilter.toJSON(message.kidsDisco)
        : undefined);
    message.kiteSurfing !== undefined &&
      (obj.kiteSurfing = message.kiteSurfing
        ? BooleanFilter.toJSON(message.kiteSurfing)
        : undefined);
    message.laundryService !== undefined &&
      (obj.laundryService = message.laundryService
        ? BooleanFilter.toJSON(message.laundryService)
        : undefined);
    message.longhaultJourney !== undefined &&
      (obj.longhaultJourney = message.longhaultJourney
        ? BooleanFilter.toJSON(message.longhaultJourney)
        : undefined);
    message.lowDeposit !== undefined &&
      (obj.lowDeposit = message.lowDeposit
        ? BooleanFilter.toJSON(message.lowDeposit)
        : undefined);
    message.luggageIncluded !== undefined &&
      (obj.luggageIncluded = message.luggageIncluded
        ? BooleanFilter.toJSON(message.luggageIncluded)
        : undefined);
    message.massages !== undefined &&
      (obj.massages = message.massages
        ? BooleanFilter.toJSON(message.massages)
        : undefined);
    message.matchOnlyCheckedAirlines !== undefined &&
      (obj.matchOnlyCheckedAirlines = message.matchOnlyCheckedAirlines
        ? BooleanFilter.toJSON(message.matchOnlyCheckedAirlines)
        : undefined);
    message.maxiClub !== undefined &&
      (obj.maxiClub = message.maxiClub
        ? BooleanFilter.toJSON(message.maxiClub)
        : undefined);
    message.medicalService !== undefined &&
      (obj.medicalService = message.medicalService
        ? BooleanFilter.toJSON(message.medicalService)
        : undefined);
    message.miniClub !== undefined &&
      (obj.miniClub = message.miniClub
        ? BooleanFilter.toJSON(message.miniClub)
        : undefined);
    message.niceSmallFamilyRun !== undefined &&
      (obj.niceSmallFamilyRun = message.niceSmallFamilyRun
        ? BooleanFilter.toJSON(message.niceSmallFamilyRun)
        : undefined);
    message.nonSmokingHotel !== undefined &&
      (obj.nonSmokingHotel = message.nonSmokingHotel
        ? BooleanFilter.toJSON(message.nonSmokingHotel)
        : undefined);
    message.nonSmokingRooms !== undefined &&
      (obj.nonSmokingRooms = message.nonSmokingRooms
        ? BooleanFilter.toJSON(message.nonSmokingRooms)
        : undefined);
    message.oceanView !== undefined &&
      (obj.oceanView = message.oceanView
        ? BooleanFilter.toJSON(message.oceanView)
        : undefined);
    message.parkingSpacesAvailable !== undefined &&
      (obj.parkingSpacesAvailable = message.parkingSpacesAvailable
        ? BooleanFilter.toJSON(message.parkingSpacesAvailable)
        : undefined);
    message.partialOceanView !== undefined &&
      (obj.partialOceanView = message.partialOceanView
        ? BooleanFilter.toJSON(message.partialOceanView)
        : undefined);
    message.petsAllowed !== undefined &&
      (obj.petsAllowed = message.petsAllowed
        ? BooleanFilter.toJSON(message.petsAllowed)
        : undefined);
    message.pettingZoo !== undefined &&
      (obj.pettingZoo = message.pettingZoo
        ? BooleanFilter.toJSON(message.pettingZoo)
        : undefined);
    message.pool !== undefined &&
      (obj.pool = message.pool
        ? BooleanFilter.toJSON(message.pool)
        : undefined);
    message.promoDiscount !== undefined &&
      (obj.promoDiscount = message.promoDiscount
        ? BooleanFilter.toJSON(message.promoDiscount)
        : undefined);
    message.railAndFly !== undefined &&
      (obj.railAndFly = message.railAndFly
        ? BooleanFilter.toJSON(message.railAndFly)
        : undefined);
    message.relaxationOffersForBodyAndSoul !== undefined &&
      (obj.relaxationOffersForBodyAndSoul =
        message.relaxationOffersForBodyAndSoul
          ? BooleanFilter.toJSON(message.relaxationOffersForBodyAndSoul)
          : undefined);
    message.restaurant !== undefined &&
      (obj.restaurant = message.restaurant
        ? BooleanFilter.toJSON(message.restaurant)
        : undefined);
    message.sailing !== undefined &&
      (obj.sailing = message.sailing
        ? BooleanFilter.toJSON(message.sailing)
        : undefined);
    message.sandyBeach !== undefined &&
      (obj.sandyBeach = message.sandyBeach
        ? BooleanFilter.toJSON(message.sandyBeach)
        : undefined);
    message.sauna !== undefined &&
      (obj.sauna = message.sauna
        ? BooleanFilter.toJSON(message.sauna)
        : undefined);
    message.singleWithChild !== undefined &&
      (obj.singleWithChild = message.singleWithChild
        ? BooleanFilter.toJSON(message.singleWithChild)
        : undefined);
    message.singles !== undefined &&
      (obj.singles = message.singles
        ? BooleanFilter.toJSON(message.singles)
        : undefined);
    message.soccerSchool !== undefined &&
      (obj.soccerSchool = message.soccerSchool
        ? BooleanFilter.toJSON(message.soccerSchool)
        : undefined);
    message.specialCommission !== undefined &&
      (obj.specialCommission = message.specialCommission
        ? BooleanFilter.toJSON(message.specialCommission)
        : undefined);
    message.sportOffersForChildren !== undefined &&
      (obj.sportOffersForChildren = message.sportOffersForChildren
        ? BooleanFilter.toJSON(message.sportOffersForChildren)
        : undefined);
    message.squash !== undefined &&
      (obj.squash = message.squash
        ? BooleanFilter.toJSON(message.squash)
        : undefined);
    message.surfing !== undefined &&
      (obj.surfing = message.surfing
        ? BooleanFilter.toJSON(message.surfing)
        : undefined);
    message.swimSchool !== undefined &&
      (obj.swimSchool = message.swimSchool
        ? BooleanFilter.toJSON(message.swimSchool)
        : undefined);
    message.tennis !== undefined &&
      (obj.tennis = message.tennis
        ? BooleanFilter.toJSON(message.tennis)
        : undefined);
    message.thalasso !== undefined &&
      (obj.thalasso = message.thalasso
        ? BooleanFilter.toJSON(message.thalasso)
        : undefined);
    message.transfer !== undefined &&
      (obj.transfer = message.transfer
        ? BooleanFilter.toJSON(message.transfer)
        : undefined);
    message.privateTransfer !== undefined &&
      (obj.privateTransfer = message.privateTransfer
        ? BooleanFilter.toJSON(message.privateTransfer)
        : undefined);
    message.vacationAtMediterraneanSea !== undefined &&
      (obj.vacationAtMediterraneanSea = message.vacationAtMediterraneanSea
        ? BooleanFilter.toJSON(message.vacationAtMediterraneanSea)
        : undefined);
    message.vacationAtNorthOrBalticSea !== undefined &&
      (obj.vacationAtNorthOrBalticSea = message.vacationAtNorthOrBalticSea
        ? BooleanFilter.toJSON(message.vacationAtNorthOrBalticSea)
        : undefined);
    message.vacationInAustria !== undefined &&
      (obj.vacationInAustria = message.vacationInAustria
        ? BooleanFilter.toJSON(message.vacationInAustria)
        : undefined);
    message.vacationInGermany !== undefined &&
      (obj.vacationInGermany = message.vacationInGermany
        ? BooleanFilter.toJSON(message.vacationInGermany)
        : undefined);
    message.vacationInTheMountains !== undefined &&
      (obj.vacationInTheMountains = message.vacationInTheMountains
        ? BooleanFilter.toJSON(message.vacationInTheMountains)
        : undefined);
    message.waterSlide !== undefined &&
      (obj.waterSlide = message.waterSlide
        ? BooleanFilter.toJSON(message.waterSlide)
        : undefined);
    message.waterSports !== undefined &&
      (obj.waterSports = message.waterSports
        ? BooleanFilter.toJSON(message.waterSports)
        : undefined);
    message.wellness !== undefined &&
      (obj.wellness = message.wellness
        ? BooleanFilter.toJSON(message.wellness)
        : undefined);
    message.windSurfing !== undefined &&
      (obj.windSurfing = message.windSurfing
        ? BooleanFilter.toJSON(message.windSurfing)
        : undefined);
    message.wingFoiling !== undefined &&
      (obj.wingFoiling = message.wingFoiling
        ? BooleanFilter.toJSON(message.wingFoiling)
        : undefined);
    message.winterSports !== undefined &&
      (obj.winterSports = message.winterSports
        ? BooleanFilter.toJSON(message.winterSports)
        : undefined);
    if (message.areaId) {
      obj.areaId = message.areaId.map((e) =>
        e ? UintFilter.toJSON(e) : undefined
      );
    } else {
      obj.areaId = [];
    }
    if (message.cityId) {
      obj.cityId = message.cityId.map((e) =>
        e ? UintFilter.toJSON(e) : undefined
      );
    } else {
      obj.cityId = [];
    }
    if (message.hotelCategoryList) {
      obj.hotelCategoryList = message.hotelCategoryList.map((e) =>
        e ? UintFilter.toJSON(e) : undefined
      );
    } else {
      obj.hotelCategoryList = [];
    }
    if (message.unitIds) {
      obj.unitIds = message.unitIds.map((e) =>
        e ? UintFilter.toJSON(e) : undefined
      );
    } else {
      obj.unitIds = [];
    }
    if (message.cancellationDaysBeforeTravelStart) {
      obj.cancellationDaysBeforeTravelStart =
        message.cancellationDaysBeforeTravelStart.map((e) =>
          e ? UintFilter.toJSON(e) : undefined
        );
    } else {
      obj.cancellationDaysBeforeTravelStart = [];
    }
    if (message.rating) {
      obj.rating = message.rating.map((e) =>
        e ? FloatFilter.toJSON(e) : undefined
      );
    } else {
      obj.rating = [];
    }
    if (message.accommodationType) {
      obj.accommodationType = message.accommodationType.map((e) =>
        e ? StringFilter.toJSON(e) : undefined
      );
    } else {
      obj.accommodationType = [];
    }
    if (message.accommodationCategoryGroup) {
      obj.accommodationCategoryGroup = message.accommodationCategoryGroup.map(
        (e) => (e ? StringFilter.toJSON(e) : undefined)
      );
    } else {
      obj.accommodationCategoryGroup = [];
    }
    if (message.airlineList) {
      obj.airlineList = message.airlineList.map((e) =>
        e ? StringFilter.toJSON(e) : undefined
      );
    } else {
      obj.airlineList = [];
    }
    if (message.cateringList) {
      obj.cateringList = message.cateringList.map((e) =>
        e ? StringFilter.toJSON(e) : undefined
      );
    } else {
      obj.cateringList = [];
    }
    if (message.offerPaymentTypeList) {
      obj.offerPaymentTypeList = message.offerPaymentTypeList.map((e) =>
        e ? StringFilter.toJSON(e) : undefined
      );
    } else {
      obj.offerPaymentTypeList = [];
    }
    if (message.roomType) {
      obj.roomType = message.roomType.map((e) =>
        e ? StringFilter.toJSON(e) : undefined
      );
    } else {
      obj.roomType = [];
    }
    if (message.touroperator) {
      obj.touroperator = message.touroperator.map((e) =>
        e ? StringFilter.toJSON(e) : undefined
      );
    } else {
      obj.touroperator = [];
    }
    if (message.destinationAirportList) {
      obj.destinationAirportList = message.destinationAirportList.map((e) =>
        e ? AirportFilter.toJSON(e) : undefined
      );
    } else {
      obj.destinationAirportList = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<FilterItems>): FilterItems {
    const message = createBaseFilterItems();
    message.actionAndFun =
      object.actionAndFun !== undefined && object.actionAndFun !== null
        ? BooleanFilter.fromPartial(object.actionAndFun)
        : undefined;
    message.adultsOnly =
      object.adultsOnly !== undefined && object.adultsOnly !== null
        ? BooleanFilter.fromPartial(object.adultsOnly)
        : undefined;
    message.ayurveda =
      object.ayurveda !== undefined && object.ayurveda !== null
        ? BooleanFilter.fromPartial(object.ayurveda)
        : undefined;
    message.babyCot =
      object.babyCot !== undefined && object.babyCot !== null
        ? BooleanFilter.fromPartial(object.babyCot)
        : undefined;
    message.babyEquipment =
      object.babyEquipment !== undefined && object.babyEquipment !== null
        ? BooleanFilter.fromPartial(object.babyEquipment)
        : undefined;
    message.babySitting =
      object.babySitting !== undefined && object.babySitting !== null
        ? BooleanFilter.fromPartial(object.babySitting)
        : undefined;
    message.beautyFarm =
      object.beautyFarm !== undefined && object.beautyFarm !== null
        ? BooleanFilter.fromPartial(object.beautyFarm)
        : undefined;
    message.buggyRent =
      object.buggyRent !== undefined && object.buggyRent !== null
        ? BooleanFilter.fromPartial(object.buggyRent)
        : undefined;
    message.cancellationOption =
      object.cancellationOption !== undefined &&
      object.cancellationOption !== null
        ? BooleanFilter.fromPartial(object.cancellationOption)
        : undefined;
    message.cancellationCost =
      object.cancellationCost !== undefined && object.cancellationCost !== null
        ? BooleanFilter.fromPartial(object.cancellationCost)
        : undefined;
    message.cancellationShortlyBefore =
      object.cancellationShortlyBefore !== undefined &&
      object.cancellationShortlyBefore !== null
        ? BooleanFilter.fromPartial(object.cancellationShortlyBefore)
        : undefined;
    message.centralLocation =
      object.centralLocation !== undefined && object.centralLocation !== null
        ? BooleanFilter.fromPartial(object.centralLocation)
        : undefined;
    message.charmFlair =
      object.charmFlair !== undefined && object.charmFlair !== null
        ? BooleanFilter.fromPartial(object.charmFlair)
        : undefined;
    message.childFriendly =
      object.childFriendly !== undefined && object.childFriendly !== null
        ? BooleanFilter.fromPartial(object.childFriendly)
        : undefined;
    message.childrenBuffet =
      object.childrenBuffet !== undefined && object.childrenBuffet !== null
        ? BooleanFilter.fromPartial(object.childrenBuffet)
        : undefined;
    message.childrenPlayground =
      object.childrenPlayground !== undefined &&
      object.childrenPlayground !== null
        ? BooleanFilter.fromPartial(object.childrenPlayground)
        : undefined;
    message.childrenPlayroom =
      object.childrenPlayroom !== undefined && object.childrenPlayroom !== null
        ? BooleanFilter.fromPartial(object.childrenPlayroom)
        : undefined;
    message.childrenPool =
      object.childrenPool !== undefined && object.childrenPool !== null
        ? BooleanFilter.fromPartial(object.childrenPool)
        : undefined;
    message.cityBreaks =
      object.cityBreaks !== undefined && object.cityBreaks !== null
        ? BooleanFilter.fromPartial(object.cityBreaks)
        : undefined;
    message.club =
      object.club !== undefined && object.club !== null
        ? BooleanFilter.fromPartial(object.club)
        : undefined;
    message.cosmetic =
      object.cosmetic !== undefined && object.cosmetic !== null
        ? BooleanFilter.fromPartial(object.cosmetic)
        : undefined;
    message.culinaryDelights =
      object.culinaryDelights !== undefined && object.culinaryDelights !== null
        ? BooleanFilter.fromPartial(object.culinaryDelights)
        : undefined;
    message.cycling =
      object.cycling !== undefined && object.cycling !== null
        ? BooleanFilter.fromPartial(object.cycling)
        : undefined;
    message.deluxe =
      object.deluxe !== undefined && object.deluxe !== null
        ? BooleanFilter.fromPartial(object.deluxe)
        : undefined;
    message.directBeachAccess =
      object.directBeachAccess !== undefined &&
      object.directBeachAccess !== null
        ? BooleanFilter.fromPartial(object.directBeachAccess)
        : undefined;
    message.directFlight =
      object.directFlight !== undefined && object.directFlight !== null
        ? BooleanFilter.fromPartial(object.directFlight)
        : undefined;
    message.diving =
      object.diving !== undefined && object.diving !== null
        ? BooleanFilter.fromPartial(object.diving)
        : undefined;
    message.familyHoliday =
      object.familyHoliday !== undefined && object.familyHoliday !== null
        ? BooleanFilter.fromPartial(object.familyHoliday)
        : undefined;
    message.fitness =
      object.fitness !== undefined && object.fitness !== null
        ? BooleanFilter.fromPartial(object.fitness)
        : undefined;
    message.flexBooking =
      object.flexBooking !== undefined && object.flexBooking !== null
        ? BooleanFilter.fromPartial(object.flexBooking)
        : undefined;
    message.freeParking =
      object.freeParking !== undefined && object.freeParking !== null
        ? BooleanFilter.fromPartial(object.freeParking)
        : undefined;
    message.freeWlan =
      object.freeWlan !== undefined && object.freeWlan !== null
        ? BooleanFilter.fromPartial(object.freeWlan)
        : undefined;
    message.gentlySlopingSandyBeach =
      object.gentlySlopingSandyBeach !== undefined &&
      object.gentlySlopingSandyBeach !== null
        ? BooleanFilter.fromPartial(object.gentlySlopingSandyBeach)
        : undefined;
    message.germanSpeakingEntertainmentForKids =
      object.germanSpeakingEntertainmentForKids !== undefined &&
      object.germanSpeakingEntertainmentForKids !== null
        ? BooleanFilter.fromPartial(object.germanSpeakingEntertainmentForKids)
        : undefined;
    message.golf =
      object.golf !== undefined && object.golf !== null
        ? BooleanFilter.fromPartial(object.golf)
        : undefined;
    message.greatSportsOffer =
      object.greatSportsOffer !== undefined && object.greatSportsOffer !== null
        ? BooleanFilter.fromPartial(object.greatSportsOffer)
        : undefined;
    message.handicappedAccessible =
      object.handicappedAccessible !== undefined &&
      object.handicappedAccessible !== null
        ? BooleanFilter.fromPartial(object.handicappedAccessible)
        : undefined;
    message.heatedPool =
      object.heatedPool !== undefined && object.heatedPool !== null
        ? BooleanFilter.fromPartial(object.heatedPool)
        : undefined;
    message.hiking =
      object.hiking !== undefined && object.hiking !== null
        ? BooleanFilter.fromPartial(object.hiking)
        : undefined;
    message.holidayForTwo =
      object.holidayForTwo !== undefined && object.holidayForTwo !== null
        ? BooleanFilter.fromPartial(object.holidayForTwo)
        : undefined;
    message.horseRiding =
      object.horseRiding !== undefined && object.horseRiding !== null
        ? BooleanFilter.fromPartial(object.horseRiding)
        : undefined;
    message.hotelNearTheBeach =
      object.hotelNearTheBeach !== undefined &&
      object.hotelNearTheBeach !== null
        ? BooleanFilter.fromPartial(object.hotelNearTheBeach)
        : undefined;
    message.indoorPool =
      object.indoorPool !== undefined && object.indoorPool !== null
        ? BooleanFilter.fromPartial(object.indoorPool)
        : undefined;
    message.internet =
      object.internet !== undefined && object.internet !== null
        ? BooleanFilter.fromPartial(object.internet)
        : undefined;
    message.kidsDisco =
      object.kidsDisco !== undefined && object.kidsDisco !== null
        ? BooleanFilter.fromPartial(object.kidsDisco)
        : undefined;
    message.kiteSurfing =
      object.kiteSurfing !== undefined && object.kiteSurfing !== null
        ? BooleanFilter.fromPartial(object.kiteSurfing)
        : undefined;
    message.laundryService =
      object.laundryService !== undefined && object.laundryService !== null
        ? BooleanFilter.fromPartial(object.laundryService)
        : undefined;
    message.longhaultJourney =
      object.longhaultJourney !== undefined && object.longhaultJourney !== null
        ? BooleanFilter.fromPartial(object.longhaultJourney)
        : undefined;
    message.lowDeposit =
      object.lowDeposit !== undefined && object.lowDeposit !== null
        ? BooleanFilter.fromPartial(object.lowDeposit)
        : undefined;
    message.luggageIncluded =
      object.luggageIncluded !== undefined && object.luggageIncluded !== null
        ? BooleanFilter.fromPartial(object.luggageIncluded)
        : undefined;
    message.massages =
      object.massages !== undefined && object.massages !== null
        ? BooleanFilter.fromPartial(object.massages)
        : undefined;
    message.matchOnlyCheckedAirlines =
      object.matchOnlyCheckedAirlines !== undefined &&
      object.matchOnlyCheckedAirlines !== null
        ? BooleanFilter.fromPartial(object.matchOnlyCheckedAirlines)
        : undefined;
    message.maxiClub =
      object.maxiClub !== undefined && object.maxiClub !== null
        ? BooleanFilter.fromPartial(object.maxiClub)
        : undefined;
    message.medicalService =
      object.medicalService !== undefined && object.medicalService !== null
        ? BooleanFilter.fromPartial(object.medicalService)
        : undefined;
    message.miniClub =
      object.miniClub !== undefined && object.miniClub !== null
        ? BooleanFilter.fromPartial(object.miniClub)
        : undefined;
    message.niceSmallFamilyRun =
      object.niceSmallFamilyRun !== undefined &&
      object.niceSmallFamilyRun !== null
        ? BooleanFilter.fromPartial(object.niceSmallFamilyRun)
        : undefined;
    message.nonSmokingHotel =
      object.nonSmokingHotel !== undefined && object.nonSmokingHotel !== null
        ? BooleanFilter.fromPartial(object.nonSmokingHotel)
        : undefined;
    message.nonSmokingRooms =
      object.nonSmokingRooms !== undefined && object.nonSmokingRooms !== null
        ? BooleanFilter.fromPartial(object.nonSmokingRooms)
        : undefined;
    message.oceanView =
      object.oceanView !== undefined && object.oceanView !== null
        ? BooleanFilter.fromPartial(object.oceanView)
        : undefined;
    message.parkingSpacesAvailable =
      object.parkingSpacesAvailable !== undefined &&
      object.parkingSpacesAvailable !== null
        ? BooleanFilter.fromPartial(object.parkingSpacesAvailable)
        : undefined;
    message.partialOceanView =
      object.partialOceanView !== undefined && object.partialOceanView !== null
        ? BooleanFilter.fromPartial(object.partialOceanView)
        : undefined;
    message.petsAllowed =
      object.petsAllowed !== undefined && object.petsAllowed !== null
        ? BooleanFilter.fromPartial(object.petsAllowed)
        : undefined;
    message.pettingZoo =
      object.pettingZoo !== undefined && object.pettingZoo !== null
        ? BooleanFilter.fromPartial(object.pettingZoo)
        : undefined;
    message.pool =
      object.pool !== undefined && object.pool !== null
        ? BooleanFilter.fromPartial(object.pool)
        : undefined;
    message.promoDiscount =
      object.promoDiscount !== undefined && object.promoDiscount !== null
        ? BooleanFilter.fromPartial(object.promoDiscount)
        : undefined;
    message.railAndFly =
      object.railAndFly !== undefined && object.railAndFly !== null
        ? BooleanFilter.fromPartial(object.railAndFly)
        : undefined;
    message.relaxationOffersForBodyAndSoul =
      object.relaxationOffersForBodyAndSoul !== undefined &&
      object.relaxationOffersForBodyAndSoul !== null
        ? BooleanFilter.fromPartial(object.relaxationOffersForBodyAndSoul)
        : undefined;
    message.restaurant =
      object.restaurant !== undefined && object.restaurant !== null
        ? BooleanFilter.fromPartial(object.restaurant)
        : undefined;
    message.sailing =
      object.sailing !== undefined && object.sailing !== null
        ? BooleanFilter.fromPartial(object.sailing)
        : undefined;
    message.sandyBeach =
      object.sandyBeach !== undefined && object.sandyBeach !== null
        ? BooleanFilter.fromPartial(object.sandyBeach)
        : undefined;
    message.sauna =
      object.sauna !== undefined && object.sauna !== null
        ? BooleanFilter.fromPartial(object.sauna)
        : undefined;
    message.singleWithChild =
      object.singleWithChild !== undefined && object.singleWithChild !== null
        ? BooleanFilter.fromPartial(object.singleWithChild)
        : undefined;
    message.singles =
      object.singles !== undefined && object.singles !== null
        ? BooleanFilter.fromPartial(object.singles)
        : undefined;
    message.soccerSchool =
      object.soccerSchool !== undefined && object.soccerSchool !== null
        ? BooleanFilter.fromPartial(object.soccerSchool)
        : undefined;
    message.specialCommission =
      object.specialCommission !== undefined &&
      object.specialCommission !== null
        ? BooleanFilter.fromPartial(object.specialCommission)
        : undefined;
    message.sportOffersForChildren =
      object.sportOffersForChildren !== undefined &&
      object.sportOffersForChildren !== null
        ? BooleanFilter.fromPartial(object.sportOffersForChildren)
        : undefined;
    message.squash =
      object.squash !== undefined && object.squash !== null
        ? BooleanFilter.fromPartial(object.squash)
        : undefined;
    message.surfing =
      object.surfing !== undefined && object.surfing !== null
        ? BooleanFilter.fromPartial(object.surfing)
        : undefined;
    message.swimSchool =
      object.swimSchool !== undefined && object.swimSchool !== null
        ? BooleanFilter.fromPartial(object.swimSchool)
        : undefined;
    message.tennis =
      object.tennis !== undefined && object.tennis !== null
        ? BooleanFilter.fromPartial(object.tennis)
        : undefined;
    message.thalasso =
      object.thalasso !== undefined && object.thalasso !== null
        ? BooleanFilter.fromPartial(object.thalasso)
        : undefined;
    message.transfer =
      object.transfer !== undefined && object.transfer !== null
        ? BooleanFilter.fromPartial(object.transfer)
        : undefined;
    message.privateTransfer =
      object.privateTransfer !== undefined && object.privateTransfer !== null
        ? BooleanFilter.fromPartial(object.privateTransfer)
        : undefined;
    message.vacationAtMediterraneanSea =
      object.vacationAtMediterraneanSea !== undefined &&
      object.vacationAtMediterraneanSea !== null
        ? BooleanFilter.fromPartial(object.vacationAtMediterraneanSea)
        : undefined;
    message.vacationAtNorthOrBalticSea =
      object.vacationAtNorthOrBalticSea !== undefined &&
      object.vacationAtNorthOrBalticSea !== null
        ? BooleanFilter.fromPartial(object.vacationAtNorthOrBalticSea)
        : undefined;
    message.vacationInAustria =
      object.vacationInAustria !== undefined &&
      object.vacationInAustria !== null
        ? BooleanFilter.fromPartial(object.vacationInAustria)
        : undefined;
    message.vacationInGermany =
      object.vacationInGermany !== undefined &&
      object.vacationInGermany !== null
        ? BooleanFilter.fromPartial(object.vacationInGermany)
        : undefined;
    message.vacationInTheMountains =
      object.vacationInTheMountains !== undefined &&
      object.vacationInTheMountains !== null
        ? BooleanFilter.fromPartial(object.vacationInTheMountains)
        : undefined;
    message.waterSlide =
      object.waterSlide !== undefined && object.waterSlide !== null
        ? BooleanFilter.fromPartial(object.waterSlide)
        : undefined;
    message.waterSports =
      object.waterSports !== undefined && object.waterSports !== null
        ? BooleanFilter.fromPartial(object.waterSports)
        : undefined;
    message.wellness =
      object.wellness !== undefined && object.wellness !== null
        ? BooleanFilter.fromPartial(object.wellness)
        : undefined;
    message.windSurfing =
      object.windSurfing !== undefined && object.windSurfing !== null
        ? BooleanFilter.fromPartial(object.windSurfing)
        : undefined;
    message.wingFoiling =
      object.wingFoiling !== undefined && object.wingFoiling !== null
        ? BooleanFilter.fromPartial(object.wingFoiling)
        : undefined;
    message.winterSports =
      object.winterSports !== undefined && object.winterSports !== null
        ? BooleanFilter.fromPartial(object.winterSports)
        : undefined;
    message.areaId = object.areaId?.map((e) => UintFilter.fromPartial(e)) || [];
    message.cityId = object.cityId?.map((e) => UintFilter.fromPartial(e)) || [];
    message.hotelCategoryList =
      object.hotelCategoryList?.map((e) => UintFilter.fromPartial(e)) || [];
    message.unitIds =
      object.unitIds?.map((e) => UintFilter.fromPartial(e)) || [];
    message.cancellationDaysBeforeTravelStart =
      object.cancellationDaysBeforeTravelStart?.map((e) =>
        UintFilter.fromPartial(e)
      ) || [];
    message.rating =
      object.rating?.map((e) => FloatFilter.fromPartial(e)) || [];
    message.accommodationType =
      object.accommodationType?.map((e) => StringFilter.fromPartial(e)) || [];
    message.accommodationCategoryGroup =
      object.accommodationCategoryGroup?.map((e) =>
        StringFilter.fromPartial(e)
      ) || [];
    message.airlineList =
      object.airlineList?.map((e) => StringFilter.fromPartial(e)) || [];
    message.cateringList =
      object.cateringList?.map((e) => StringFilter.fromPartial(e)) || [];
    message.offerPaymentTypeList =
      object.offerPaymentTypeList?.map((e) => StringFilter.fromPartial(e)) ||
      [];
    message.roomType =
      object.roomType?.map((e) => StringFilter.fromPartial(e)) || [];
    message.touroperator =
      object.touroperator?.map((e) => StringFilter.fromPartial(e)) || [];
    message.destinationAirportList =
      object.destinationAirportList?.map((e) => AirportFilter.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseFavouriteFilters(): FavouriteFilters {
  return {
    filterOptionsDisplayMode: "",
    filterOptionsRenderMode: "",
    filterOptionsList: [],
    customerFilters: [],
  };
}

export const FavouriteFilters = {
  encode(
    message: FavouriteFilters,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.filterOptionsDisplayMode !== "") {
      writer.uint32(10).string(message.filterOptionsDisplayMode);
    }
    if (message.filterOptionsRenderMode !== "") {
      writer.uint32(18).string(message.filterOptionsRenderMode);
    }
    for (const v of message.filterOptionsList) {
      FavouriteFilters_FilterOption.encode(
        v!,
        writer.uint32(26).fork()
      ).ldelim();
    }
    for (const v of message.customerFilters) {
      FavouriteFilters_FilterOption.encode(
        v!,
        writer.uint32(34).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FavouriteFilters {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFavouriteFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.filterOptionsDisplayMode = reader.string();
          break;
        case 2:
          message.filterOptionsRenderMode = reader.string();
          break;
        case 3:
          message.filterOptionsList.push(
            FavouriteFilters_FilterOption.decode(reader, reader.uint32())
          );
          break;
        case 4:
          message.customerFilters.push(
            FavouriteFilters_FilterOption.decode(reader, reader.uint32())
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FavouriteFilters {
    return {
      filterOptionsDisplayMode: isSet(object.filterOptionsDisplayMode)
        ? String(object.filterOptionsDisplayMode)
        : "",
      filterOptionsRenderMode: isSet(object.filterOptionsRenderMode)
        ? String(object.filterOptionsRenderMode)
        : "",
      filterOptionsList: Array.isArray(object?.filterOptionsList)
        ? object.filterOptionsList.map((e: any) =>
            FavouriteFilters_FilterOption.fromJSON(e)
          )
        : [],
      customerFilters: Array.isArray(object?.customerFilters)
        ? object.customerFilters.map((e: any) =>
            FavouriteFilters_FilterOption.fromJSON(e)
          )
        : [],
    };
  },

  toJSON(message: FavouriteFilters): unknown {
    const obj: any = {};
    message.filterOptionsDisplayMode !== undefined &&
      (obj.filterOptionsDisplayMode = message.filterOptionsDisplayMode);
    message.filterOptionsRenderMode !== undefined &&
      (obj.filterOptionsRenderMode = message.filterOptionsRenderMode);
    if (message.filterOptionsList) {
      obj.filterOptionsList = message.filterOptionsList.map((e) =>
        e ? FavouriteFilters_FilterOption.toJSON(e) : undefined
      );
    } else {
      obj.filterOptionsList = [];
    }
    if (message.customerFilters) {
      obj.customerFilters = message.customerFilters.map((e) =>
        e ? FavouriteFilters_FilterOption.toJSON(e) : undefined
      );
    } else {
      obj.customerFilters = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<FavouriteFilters>): FavouriteFilters {
    const message = createBaseFavouriteFilters();
    message.filterOptionsDisplayMode = object.filterOptionsDisplayMode ?? "";
    message.filterOptionsRenderMode = object.filterOptionsRenderMode ?? "";
    message.filterOptionsList =
      object.filterOptionsList?.map((e) =>
        FavouriteFilters_FilterOption.fromPartial(e)
      ) || [];
    message.customerFilters =
      object.customerFilters?.map((e) =>
        FavouriteFilters_FilterOption.fromPartial(e)
      ) || [];
    return message;
  },
};

function createBaseFavouriteFilters_FilterOption(): FavouriteFilters_FilterOption {
  return {
    count: 0,
    source: "",
    originalValue: "",
    filterKey: "",
    input: undefined,
    label: undefined,
    potential: undefined,
  };
}

export const FavouriteFilters_FilterOption = {
  encode(
    message: FavouriteFilters_FilterOption,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.count !== 0) {
      writer.uint32(8).uint32(message.count);
    }
    if (message.source !== "") {
      writer.uint32(42).string(message.source);
    }
    if (message.originalValue !== "") {
      writer.uint32(50).string(message.originalValue);
    }
    if (message.filterKey !== "") {
      writer.uint32(58).string(message.filterKey);
    }
    if (message.input !== undefined) {
      FavouriteFilters_FilterOption_Input.encode(
        message.input,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.label !== undefined) {
      FavouriteFilters_FilterOption_Label.encode(
        message.label,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.potential !== undefined) {
      FavouriteFilters_FilterOption_Potential.encode(
        message.potential,
        writer.uint32(34).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FavouriteFilters_FilterOption {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFavouriteFilters_FilterOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.count = reader.uint32();
          break;
        case 5:
          message.source = reader.string();
          break;
        case 6:
          message.originalValue = reader.string();
          break;
        case 7:
          message.filterKey = reader.string();
          break;
        case 2:
          message.input = FavouriteFilters_FilterOption_Input.decode(
            reader,
            reader.uint32()
          );
          break;
        case 3:
          message.label = FavouriteFilters_FilterOption_Label.decode(
            reader,
            reader.uint32()
          );
          break;
        case 4:
          message.potential = FavouriteFilters_FilterOption_Potential.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FavouriteFilters_FilterOption {
    return {
      count: isSet(object.count) ? Number(object.count) : 0,
      source: isSet(object.source) ? String(object.source) : "",
      originalValue: isSet(object.originalValue)
        ? String(object.originalValue)
        : "",
      filterKey: isSet(object.filterKey) ? String(object.filterKey) : "",
      input: isSet(object.input)
        ? FavouriteFilters_FilterOption_Input.fromJSON(object.input)
        : undefined,
      label: isSet(object.label)
        ? FavouriteFilters_FilterOption_Label.fromJSON(object.label)
        : undefined,
      potential: isSet(object.potential)
        ? FavouriteFilters_FilterOption_Potential.fromJSON(object.potential)
        : undefined,
    };
  },

  toJSON(message: FavouriteFilters_FilterOption): unknown {
    const obj: any = {};
    message.count !== undefined && (obj.count = Math.round(message.count));
    message.source !== undefined && (obj.source = message.source);
    message.originalValue !== undefined &&
      (obj.originalValue = message.originalValue);
    message.filterKey !== undefined && (obj.filterKey = message.filterKey);
    message.input !== undefined &&
      (obj.input = message.input
        ? FavouriteFilters_FilterOption_Input.toJSON(message.input)
        : undefined);
    message.label !== undefined &&
      (obj.label = message.label
        ? FavouriteFilters_FilterOption_Label.toJSON(message.label)
        : undefined);
    message.potential !== undefined &&
      (obj.potential = message.potential
        ? FavouriteFilters_FilterOption_Potential.toJSON(message.potential)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<FavouriteFilters_FilterOption>
  ): FavouriteFilters_FilterOption {
    const message = createBaseFavouriteFilters_FilterOption();
    message.count = object.count ?? 0;
    message.source = object.source ?? "";
    message.originalValue = object.originalValue ?? "";
    message.filterKey = object.filterKey ?? "";
    message.input =
      object.input !== undefined && object.input !== null
        ? FavouriteFilters_FilterOption_Input.fromPartial(object.input)
        : undefined;
    message.label =
      object.label !== undefined && object.label !== null
        ? FavouriteFilters_FilterOption_Label.fromPartial(object.label)
        : undefined;
    message.potential =
      object.potential !== undefined && object.potential !== null
        ? FavouriteFilters_FilterOption_Potential.fromPartial(object.potential)
        : undefined;
    return message;
  },
};

function createBaseFavouriteFilters_FilterOption_Input(): FavouriteFilters_FilterOption_Input {
  return {
    isChecked: false,
    id: "",
    name: "",
    value: "",
    paramMapKey: "",
    class: "",
  };
}

export const FavouriteFilters_FilterOption_Input = {
  encode(
    message: FavouriteFilters_FilterOption_Input,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isChecked === true) {
      writer.uint32(32).bool(message.isChecked);
    }
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(26).string(message.value);
    }
    if (message.paramMapKey !== "") {
      writer.uint32(42).string(message.paramMapKey);
    }
    if (message.class !== "") {
      writer.uint32(50).string(message.class);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FavouriteFilters_FilterOption_Input {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFavouriteFilters_FilterOption_Input();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.isChecked = reader.bool();
          break;
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.name = reader.string();
          break;
        case 3:
          message.value = reader.string();
          break;
        case 5:
          message.paramMapKey = reader.string();
          break;
        case 6:
          message.class = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FavouriteFilters_FilterOption_Input {
    return {
      isChecked: isSet(object.isChecked) ? Boolean(object.isChecked) : false,
      id: isSet(object.id) ? String(object.id) : "",
      name: isSet(object.name) ? String(object.name) : "",
      value: isSet(object.value) ? String(object.value) : "",
      paramMapKey: isSet(object.paramMapKey) ? String(object.paramMapKey) : "",
      class: isSet(object.class) ? String(object.class) : "",
    };
  },

  toJSON(message: FavouriteFilters_FilterOption_Input): unknown {
    const obj: any = {};
    message.isChecked !== undefined && (obj.isChecked = message.isChecked);
    message.id !== undefined && (obj.id = message.id);
    message.name !== undefined && (obj.name = message.name);
    message.value !== undefined && (obj.value = message.value);
    message.paramMapKey !== undefined &&
      (obj.paramMapKey = message.paramMapKey);
    message.class !== undefined && (obj.class = message.class);
    return obj;
  },

  fromPartial(
    object: DeepPartial<FavouriteFilters_FilterOption_Input>
  ): FavouriteFilters_FilterOption_Input {
    const message = createBaseFavouriteFilters_FilterOption_Input();
    message.isChecked = object.isChecked ?? false;
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    message.paramMapKey = object.paramMapKey ?? "";
    message.class = object.class ?? "";
    return message;
  },
};

function createBaseFavouriteFilters_FilterOption_Label(): FavouriteFilters_FilterOption_Label {
  return { text: "", title: "", class: "", spanClass: "" };
}

export const FavouriteFilters_FilterOption_Label = {
  encode(
    message: FavouriteFilters_FilterOption_Label,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.class !== "") {
      writer.uint32(26).string(message.class);
    }
    if (message.spanClass !== "") {
      writer.uint32(34).string(message.spanClass);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FavouriteFilters_FilterOption_Label {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFavouriteFilters_FilterOption_Label();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.text = reader.string();
          break;
        case 2:
          message.title = reader.string();
          break;
        case 3:
          message.class = reader.string();
          break;
        case 4:
          message.spanClass = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FavouriteFilters_FilterOption_Label {
    return {
      text: isSet(object.text) ? String(object.text) : "",
      title: isSet(object.title) ? String(object.title) : "",
      class: isSet(object.class) ? String(object.class) : "",
      spanClass: isSet(object.spanClass) ? String(object.spanClass) : "",
    };
  },

  toJSON(message: FavouriteFilters_FilterOption_Label): unknown {
    const obj: any = {};
    message.text !== undefined && (obj.text = message.text);
    message.title !== undefined && (obj.title = message.title);
    message.class !== undefined && (obj.class = message.class);
    message.spanClass !== undefined && (obj.spanClass = message.spanClass);
    return obj;
  },

  fromPartial(
    object: DeepPartial<FavouriteFilters_FilterOption_Label>
  ): FavouriteFilters_FilterOption_Label {
    const message = createBaseFavouriteFilters_FilterOption_Label();
    message.text = object.text ?? "";
    message.title = object.title ?? "";
    message.class = object.class ?? "";
    message.spanClass = object.spanClass ?? "";
    return message;
  },
};

function createBaseFavouriteFilters_FilterOption_Potential(): FavouriteFilters_FilterOption_Potential {
  return { show: false, showFilterCount: false, id: "" };
}

export const FavouriteFilters_FilterOption_Potential = {
  encode(
    message: FavouriteFilters_FilterOption_Potential,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.show === true) {
      writer.uint32(8).bool(message.show);
    }
    if (message.showFilterCount === true) {
      writer.uint32(16).bool(message.showFilterCount);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FavouriteFilters_FilterOption_Potential {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFavouriteFilters_FilterOption_Potential();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.show = reader.bool();
          break;
        case 2:
          message.showFilterCount = reader.bool();
          break;
        case 3:
          message.id = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FavouriteFilters_FilterOption_Potential {
    return {
      show: isSet(object.show) ? Boolean(object.show) : false,
      showFilterCount: isSet(object.showFilterCount)
        ? Boolean(object.showFilterCount)
        : false,
      id: isSet(object.id) ? String(object.id) : "",
    };
  },

  toJSON(message: FavouriteFilters_FilterOption_Potential): unknown {
    const obj: any = {};
    message.show !== undefined && (obj.show = message.show);
    message.showFilterCount !== undefined &&
      (obj.showFilterCount = message.showFilterCount);
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },

  fromPartial(
    object: DeepPartial<FavouriteFilters_FilterOption_Potential>
  ): FavouriteFilters_FilterOption_Potential {
    const message = createBaseFavouriteFilters_FilterOption_Potential();
    message.show = object.show ?? false;
    message.showFilterCount = object.showFilterCount ?? false;
    message.id = object.id ?? "";
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
